﻿/* ============================================================
   MyPokea — Pokédex page logic
   ============================================================ */

const params = new URLSearchParams(location.search);
const GEN_NUM = Math.max(1, Math.min(10, parseInt(window.GEN_NUM_FROM_LIQUID || params.get("gen") || "1", 10)));
const INITIAL_Q = params.get("q") || "";
const INITIAL_TYPE = params.get("type") || ""; // ex. ?type=spectre depuis la recherche globale (chrome.js)

/* Vraie photo produit du site, jamais un sprite officiel — utilisée quand aucune photo
   réelle n'existe encore pour un Pokémon donné. */
const GENERIC_REAL_FALLBACK_IMG = "https://cdn.shopify.com/s/files/1/0972/9173/1277/files/Pokemon-Bulbizarre-Bulbasaur-Bisasam-001-figurine-finger-puppet-v4.webp?v=1782133857";

const GEN_STARTERS = {
  1:[1,4,7], 2:[152,155,158], 3:[252,255,258], 4:[387,390,393],
  5:[495,498,501], 6:[650,653,656], 7:[722,725,728], 8:[810,813,816], 9:[906,909,912],
};

/* Légendaires par génération pour le hero — 3 Pokémon distincts garantis, jamais de doublon */
const GEN_HERO_LEGENDARIES = {
  1: [{id:150,name:'Mewtwo'},{id:145,name:'Électhor'},{id:144,name:'Artikodin'}],
  2: [{id:249,name:'Lugia'},{id:250,name:'Ho-Oh'},{id:245,name:'Suicune'}],
  3: [{id:382,name:'Kyogre'},{id:383,name:'Groudon'},{id:384,name:'Rayquaza'}],
  4: [{id:483,name:'Dialga'},{id:484,name:'Palkia'},{id:487,name:'Giratina'}],
  5: [{id:643,name:'Reshiram'},{id:644,name:'Zekrom'},{id:646,name:'Kyurem'}],
  6: [{id:716,name:'Xerneas'},{id:717,name:'Yveltal'},{id:718,name:'Zygarde'}],
  7: [{id:791,name:'Solgaleo'},{id:792,name:'Lunala'},{id:800,name:'Necrozma'}],
  8: [{id:888,name:'Zacian'},{id:889,name:'Zamazenta'},{id:890,name:'Éternatus'}],
  9: [{id:1007,name:'Koraidon'},{id:1008,name:'Miraidon'},{id:1024,name:'Terapagos'}],
};

function _altStd(name, num) {
  const parts = ['Finger puppet', 'Figurine Pokémon', 'Pokémon Kids', name || ''];
  if (num != null) parts.push('N°' + String(num).padStart(3, '0'));
  return parts.join(' | ');
}
function _altFromTitle(title) {
  if (!title) return '';
  let t = title;
  for (let i = 0; i < 4; i++) {
    const before = t;
    t = t.replace(/^(boite|boîte)\s+/i, '').replace(/^pok[eé]mon\s+/i, '').replace(/^figurine\s+/i, '');
    if (t === before) break;
  }
  const numMatch = t.match(/n[°º]\s*0*(\d+)/i);
  const num = numMatch ? numMatch[1] : null;
  if (numMatch) t = t.replace(numMatch[0], ' ');
  t = t.replace(/finger\s*puppet\s*pokemon/i, '').trim();
  let nameSeg = t.split(/\s*[—–]\s*/)[0].trim();
  if (!nameSeg) nameSeg = t.trim();
  const names = nameSeg.split(/\s*\/\s*/).map(s => s.trim()).filter(Boolean);
  const parts = ['Finger puppet', 'Figurine Pokémon', 'Pokémon Kids'].concat(names.length ? names : [title]);
  if (num) parts.push('N°' + String(num).padStart(3, '0'));
  return parts.join(' | ');
}

let state = {
  q: INITIAL_Q,
  segment: "all",
  types: new Set(INITIAL_TYPE ? [INITIAL_TYPE] : []),
  sort: "num-asc",
  expand: false,
  pikaSingle: false,
};

/* —— délègue à Bundle (partagé cross-pages) */
function hasPick(key)  { return window.Bundle && Bundle.has(key); }
function togglePick(f) {
  if (!window.Bundle) return;
  Bundle.toggle({ key: f.key, num: f.num, name: f.name, variant: f.label || f.variant, price: f.price, image: f.sprite || f.image, url: f.url });
  pulseBundle();
}
function picksForNum(num) { return window.Bundle ? Bundle.picks.filter(p => p.num === num).length : 0; }
function totalPicks()     { return window.Bundle ? Bundle.picks.length : 0; }

function _isSpecialForm(title) {
  return /brillant|brillante|shiny|chromatique|transparent|crystal|cristal|m[eé]ga|gigamax|gigantamax|alola|galar|hisui|paldea|armure/i.test(title);
}
function _isTransparent(title) {
  return /transparent|cristal|crystal/i.test(title);
}
function _kantoBestFind(map, name) {
  if (!map) return undefined;
  const nonT = {};
  for (const [k, v] of Object.entries(map)) { if (!_isTransparent(k)) nonT[k] = v; }
  const r = _kantoFind(nonT, name);
  return r !== undefined ? r : _kantoFind(map, name);
}

const _KANTO_CACHE_KEY = 'mpk_kanto_v2';
const _KANTO_CACHE_TTL = 45 * 60 * 1000;
function _loadKantoCache() {
  try { const r = localStorage.getItem(_KANTO_CACHE_KEY); if (!r) return null; const {ts,data} = JSON.parse(r); return (Date.now()-ts < _KANTO_CACHE_TTL && data && data.length > 250) ? data : null; } catch { return null; }
}
function _saveKantoCache() {
  try { localStorage.setItem(_KANTO_CACHE_KEY, JSON.stringify({ts:Date.now(), data:_kantoProductsList})); } catch {}
}
function _applyKantoCacheToMaps(products) {
  (products||[]).forEach(p => {
    const key = (p.title||'').toLowerCase().trim(); if (!key) return;
    if (p.img && !_kantoImgMap[key]) _kantoImgMap[key] = p.img;
    if (p.avail !== undefined) _kantoAvailMap[key] = p.avail;
    if (p.price) _kantoPriceMap[key] = p.price;
    if (p.url && !_kantoUrlMap[key]) _kantoUrlMap[key] = p.url;
    const idx = _kantoProductsList.findIndex(x => x.url === p.url);
    if (idx < 0) _kantoProductsList.push(p); else _kantoProductsList[idx] = p;
  });
}

function _sortProducts(arr) {
  return arr.slice().sort((a, b) => {
    const aFeat = (a.feat || a.featured) ? 0 : 1;
    const bFeat = (b.feat || b.featured) ? 0 : 1;
    if (aFeat !== bFeat) return aFeat - bFeat;
    const aSpec = _isSpecialForm(a.t || a.title || '') ? 1 : 0;
    const bSpec = _isSpecialForm(b.t || b.title || '') ? 1 : 0;
    if (aSpec !== bSpec) return aSpec - bSpec;
    const ta = (a.t || a.title || '').toLowerCase();
    const tb = (b.t || b.title || '').toLowerCase();
    return ta < tb ? -1 : ta > tb ? 1 : 0;
  });
}

function buildKantoMapFromLiquid() {
  window._kantoImgMap       = {};
  window._kantoAvailMap     = {};
  window._kantoPriceMap     = {};
  window._kantoUrlMap       = {};
  window._kantoProductsList = [];
  const _kantoFeat = window.KANTO_FEATURED_HANDLES || new Set();
  _sortProducts(window.KANTO_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_kantoImgMap[key]) _kantoImgMap[key] = p.i;
    if (p.a !== undefined) _kantoAvailMap[key] = p.a;
    if (p.p != null) _kantoPriceMap[key] = p.p;
    if (p.u && !_kantoUrlMap[key]) _kantoUrlMap[key] = p.u;
    const handle = (p.u || '').split('/').pop();
    _kantoProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _kantoFeat.has(handle) });
  });
}

function buildJohtoMapFromLiquid() {
  window._johtoImgMap       = {};
  window._johtoAvailMap     = {};
  window._johtoPriceMap     = {};
  window._johtoUrlMap       = {};
  window._johtoProductsList = [];
  const _johtoFeat = window.JOHTO_FEATURED_HANDLES || new Set();
  _sortProducts(window.JOHTO_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_johtoImgMap[key]) _johtoImgMap[key] = p.i;
    if (p.a !== undefined) _johtoAvailMap[key] = p.a;
    if (p.p != null) _johtoPriceMap[key] = p.p;
    if (p.u && !_johtoUrlMap[key]) _johtoUrlMap[key] = p.u;
    const handle = (p.u || '').split('/').pop();
    _johtoProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _johtoFeat.has(handle) });
  });
}

function buildHoennMapFromLiquid() {
  window._hoennImgMap       = {};
  window._hoennAvailMap     = {};
  window._hoennPriceMap     = {};
  window._hoennUrlMap       = {};
  window._hoennProductsList = [];
  const _hoennFeat = window.HOENN_FEATURED_HANDLES || new Set();
  _sortProducts(window.HOENN_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_hoennImgMap[key]) _hoennImgMap[key] = p.i;
    if (p.a !== undefined) _hoennAvailMap[key] = p.a;
    if (p.p != null) _hoennPriceMap[key] = p.p;
    if (p.u && !_hoennUrlMap[key]) _hoennUrlMap[key] = p.u;
    const handle = (p.u || '').split('/').pop();
    _hoennProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _hoennFeat.has(handle) });
  });
}

function buildAlolaMapFromLiquid() {
  window._alolaImgMap       = {};
  window._alolaAvailMap     = {};
  window._alolaPriceMap     = {};
  window._alolaUrlMap       = {};
  window._alolaProductsList = [];
  const _alolaFeat = window.ALOLA_FEATURED_HANDLES || new Set();
  _sortProducts(window.ALOLA_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_alolaImgMap[key]) _alolaImgMap[key] = p.i;
    if (p.a !== undefined) _alolaAvailMap[key] = p.a;
    if (p.p != null) _alolaPriceMap[key] = p.p;
    if (p.u && !_alolaUrlMap[key]) _alolaUrlMap[key] = p.u;
    const numMatch = p.t.match(/n°\s*(\d+)/i);
    if (numMatch) {
      const nk = 'n°' + numMatch[1];
      if (p.i && !_alolaImgMap[nk]) _alolaImgMap[nk] = p.i;
      if (p.a !== undefined && _alolaAvailMap[nk] === undefined) _alolaAvailMap[nk] = p.a;
      if (p.p != null && !_alolaPriceMap[nk]) _alolaPriceMap[nk] = p.p;
      if (p.u && !_alolaUrlMap[nk]) _alolaUrlMap[nk] = p.u;
    }
    const handle = (p.u || '').split('/').pop();
    _alolaProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _alolaFeat.has(handle) });
  });
}

function buildGalarMapFromLiquid() {
  window._galarImgMap       = {};
  window._galarAvailMap     = {};
  window._galarPriceMap     = {};
  window._galarUrlMap       = {};
  window._galarProductsList = [];
  const _galarFeat = window.GALAR_FEATURED_HANDLES || new Set();
  _sortProducts(window.GALAR_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_galarImgMap[key]) _galarImgMap[key] = p.i;
    if (p.a !== undefined) _galarAvailMap[key] = p.a;
    if (p.p != null) _galarPriceMap[key] = p.p;
    if (p.u && !_galarUrlMap[key]) _galarUrlMap[key] = p.u;
    const numMatch = p.t.match(/n°\s*(\d+)/i);
    if (numMatch) {
      const nk = 'n°' + numMatch[1];
      if (p.i && !_galarImgMap[nk]) _galarImgMap[nk] = p.i;
      if (p.a !== undefined && _galarAvailMap[nk] === undefined) _galarAvailMap[nk] = p.a;
      if (p.p != null && !_galarPriceMap[nk]) _galarPriceMap[nk] = p.p;
      if (p.u && !_galarUrlMap[nk]) _galarUrlMap[nk] = p.u;
    }
    const handle = (p.u || '').split('/').pop();
    _galarProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _galarFeat.has(handle) });
  });
}

function buildSinnohMapFromLiquid() {
  window._sinnohImgMap       = {};
  window._sinnohAvailMap     = {};
  window._sinnohPriceMap     = {};
  window._sinnohUrlMap       = {};
  window._sinnohProductsList = [];
  const _feat = window.SINNOH_FEATURED_HANDLES || new Set();
  _sortProducts(window.SINNOH_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_sinnohImgMap[key]) _sinnohImgMap[key] = p.i;
    if (p.a !== undefined) _sinnohAvailMap[key] = p.a;
    if (p.p != null) _sinnohPriceMap[key] = p.p;
    if (p.u && !_sinnohUrlMap[key]) _sinnohUrlMap[key] = p.u;
    const numMatch = p.t.match(/n°\s*(\d+)/i);
    if (numMatch) {
      const nk = 'n°' + numMatch[1];
      if (p.i && !_sinnohImgMap[nk]) _sinnohImgMap[nk] = p.i;
      if (p.a !== undefined && _sinnohAvailMap[nk] === undefined) _sinnohAvailMap[nk] = p.a;
      if (p.p != null && !_sinnohPriceMap[nk]) _sinnohPriceMap[nk] = p.p;
      if (p.u && !_sinnohUrlMap[nk]) _sinnohUrlMap[nk] = p.u;
    }
    const handle = (p.u || '').split('/').pop();
    _sinnohProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _feat.has(handle) });
  });
}

function buildUnysMapFromLiquid() {
  window._unysImgMap       = {};
  window._unysAvailMap     = {};
  window._unysPriceMap     = {};
  window._unysUrlMap       = {};
  window._unysProductsList = [];
  const _feat = window.UNYS_FEATURED_HANDLES || new Set();
  _sortProducts(window.UNYS_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_unysImgMap[key]) _unysImgMap[key] = p.i;
    if (p.a !== undefined) _unysAvailMap[key] = p.a;
    if (p.p != null) _unysPriceMap[key] = p.p;
    if (p.u && !_unysUrlMap[key]) _unysUrlMap[key] = p.u;
    const numMatch = p.t.match(/n°\s*(\d+)/i);
    if (numMatch) {
      const nk = 'n°' + numMatch[1];
      if (p.i && !_unysImgMap[nk]) _unysImgMap[nk] = p.i;
      if (p.a !== undefined && _unysAvailMap[nk] === undefined) _unysAvailMap[nk] = p.a;
      if (p.p != null && !_unysPriceMap[nk]) _unysPriceMap[nk] = p.p;
      if (p.u && !_unysUrlMap[nk]) _unysUrlMap[nk] = p.u;
    }
    const handle = (p.u || '').split('/').pop();
    _unysProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _feat.has(handle) });
  });
}

function buildKalosMapFromLiquid() {
  window._kalosImgMap       = {};
  window._kalosAvailMap     = {};
  window._kalosPriceMap     = {};
  window._kalosUrlMap       = {};
  window._kalosProductsList = [];
  const _feat = window.KALOS_FEATURED_HANDLES || new Set();
  _sortProducts(window.KALOS_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_kalosImgMap[key]) _kalosImgMap[key] = p.i;
    if (p.a !== undefined) _kalosAvailMap[key] = p.a;
    if (p.p != null) _kalosPriceMap[key] = p.p;
    if (p.u && !_kalosUrlMap[key]) _kalosUrlMap[key] = p.u;
    const numMatch = p.t.match(/n°\s*(\d+)/i);
    if (numMatch) {
      const nk = 'n°' + numMatch[1];
      if (p.i && !_kalosImgMap[nk]) _kalosImgMap[nk] = p.i;
      if (p.a !== undefined && _kalosAvailMap[nk] === undefined) _kalosAvailMap[nk] = p.a;
      if (p.p != null && !_kalosPriceMap[nk]) _kalosPriceMap[nk] = p.p;
      if (p.u && !_kalosUrlMap[nk]) _kalosUrlMap[nk] = p.u;
    }
    const handle = (p.u || '').split('/').pop();
    _kalosProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _feat.has(handle) });
  });
}

function buildPaldeaMapFromLiquid() {
  window._paldeaImgMap       = {};
  window._paldeaAvailMap     = {};
  window._paldeaPriceMap     = {};
  window._paldeaUrlMap       = {};
  window._paldeaProductsList = [];
  const _feat = window.PALDEA_FEATURED_HANDLES || new Set();
  _sortProducts(window.PALDEA_PRODUCTS_RAW || []).forEach(p => {
    const key = p.t.toLowerCase().trim();
    if (p.i && !_paldeaImgMap[key]) _paldeaImgMap[key] = p.i;
    if (p.a !== undefined) _paldeaAvailMap[key] = p.a;
    if (p.p != null) _paldeaPriceMap[key] = p.p;
    if (p.u && !_paldeaUrlMap[key]) _paldeaUrlMap[key] = p.u;
    const numMatch = p.t.match(/n°\s*(\d+)/i);
    if (numMatch) {
      const nk = 'n°' + numMatch[1];
      if (p.i && !_paldeaImgMap[nk]) _paldeaImgMap[nk] = p.i;
      if (p.a !== undefined && _paldeaAvailMap[nk] === undefined) _paldeaAvailMap[nk] = p.a;
      if (p.p != null && !_paldeaPriceMap[nk]) _paldeaPriceMap[nk] = p.p;
      if (p.u && !_paldeaUrlMap[nk]) _paldeaUrlMap[nk] = p.u;
    }
    const handle = (p.u || '').split('/').pop();
    _paldeaProductsList.push({ title: p.t, img: p.i, avail: p.a, price: p.p, url: p.u, featured: _feat.has(handle) });
  });
}

function _shopifyAjaxFetch(collection, imgMap, priceMap, urlMap, productsList, availMap, onDone, prefetchPromise) {
  const processProducts = (products) => {
    _sortProducts(products).forEach(p => {
      const key      = p.title.toLowerCase().trim();
      const img      = p.images && p.images[0] ? p.images[0].src : null;
      const price    = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
      const url      = `/products/${p.handle}`;
      const tags     = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
      const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
      if (img && !imgMap[key]) imgMap[key] = img;
      if (price) priceMap[key] = price;
      if (!urlMap[key]) urlMap[key] = url;
      if (availMap) {
        const ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
        const totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
        availMap[key]   = ajaxAvail || totalQty > 0;
      }
      const idx = productsList.findIndex(x => x.url === url);
      const existingAvail = idx >= 0 ? productsList[idx].avail : undefined;
      const entry = { title: p.title, img, avail: availMap ? availMap[key] : existingAvail, price, url, featured };
      if (idx >= 0) productsList[idx] = entry;
      else productsList.push(entry);
    });
  };
  const fetchPage = (page, accumulated) => {
    fetch(`/collections/${collection}/products.json?limit=250&page=${page}&sort_by=title`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(({ products = [] }) => {
        const all = accumulated.concat(products);
        if (products.length === 250) { fetchPage(page + 1, all); return; }
        if (!all.length) return;
        processProducts(all);
        onDone();
      })
      .catch(() => { if (accumulated.length) { processProducts(accumulated); onDone(); } });
  };
  if (prefetchPromise) {
    prefetchPromise
      .then(pages => {
        const all = pages.flatMap(p => Array.isArray(p.products) ? p.products : []);
        if (all.length) { processProducts(all); onDone(); } else fetchPage(1, []);
      })
      .catch(() => fetchPage(1, []));
  } else {
    fetchPage(1, []);
  }
}

function _applyFeaturedImages(productsList, imgMap, genData) {
  productsList.forEach(entry => {
    if (!entry.featured || !entry.img) return;
    const entryHandle = (entry.url || '').split('/').pop().split('?')[0];
    const titlePrimary = entry.title.replace(/\s+avec\s+.*/i, '');
    let poke = genData.find(p => _matchesPoke(titlePrimary, p.name));
    if (!poke) {
      const hNorm = _deAccent(entryHandle);
      poke = genData.find(p => {
        const n = _deAccent(p.name);
        return hNorm.startsWith(n + '-') || hNorm === n;
      });
    }
    if (poke) imgMap[poke.name.toLowerCase().trim()] = entry.img;
  });
}

document.addEventListener("DOMContentLoaded", () => {

  window._bundleSyncBadges = syncTileBadges;
  window._dresseursProductsList = [];
  renderGenStrip();

  // Show the SEO block matching the current gen (all others stay hidden)
  document.querySelectorAll('.gen-seo-content').forEach(el => {
    el.style.display = parseInt(el.dataset.gen, 10) === GEN_NUM ? '' : 'none';
  });

  if (GEN_NUM === 1) {
    buildKantoMapFromLiquid();
    const _kantoCached = _loadKantoCache();
    if (_kantoCached) {
      _applyKantoCacheToMaps(_kantoCached);
      _applyFeaturedImages(_kantoProductsList, _kantoImgMap, POKE.GEN1);
      window._kantoReadyFromCache = true;
    }
    renderContent();
    updateHeroImages();
    _shopifyAjaxFetch('kanto', _kantoImgMap, _kantoPriceMap, _kantoUrlMap, _kantoProductsList, _kantoAvailMap, () => {
      _saveKantoCache();
      _applyFeaturedImages(_kantoProductsList, _kantoImgMap, POKE.GEN1);
      if (!_kantoCached) {
        renderGrid();
        updateHeroImages();
      }
    }, window._kantoPrefetch);
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 2) {
    buildJohtoMapFromLiquid();
    renderContent();
    updateHeroImages();
    _shopifyAjaxFetch('johto', _johtoImgMap, _johtoPriceMap, _johtoUrlMap, _johtoProductsList, _johtoAvailMap, () => {
      _applyFeaturedImages(_johtoProductsList, _johtoImgMap, POKE.GEN2);
      renderGrid();
      updateHeroImages();
    });
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 3) {
    buildHoennMapFromLiquid();
    renderContent();
    updateHeroImages();
    (async () => {
      for (const h of ['hoenn', 'gen-3', 'generation-3', 'hoenn-region', 'pokemon-hoenn']) {
        try {
          let hoennAll = [];
          for (let pg = 1; pg <= 10; pg++) {
            const r = await fetch(`/collections/${h}/products.json?limit=250&page=${pg}&sort_by=title`);
            if (!r.ok) break;
            const { products = [] } = await r.json();
            hoennAll = hoennAll.concat(products);
            if (products.length < 250) break;
          }
          if (!hoennAll.length) continue;
          _sortProducts(hoennAll).forEach(p => {
            const key = p.title.toLowerCase().trim();
            const img = p.images && p.images[0] ? p.images[0].src : null;
            const price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
            const url = `/products/${p.handle}`;
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
            if (img && !_hoennImgMap[key]) _hoennImgMap[key] = img;
            if (price) _hoennPriceMap[key] = price;
            if (!_hoennUrlMap[key]) _hoennUrlMap[key] = url;
            const _ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
            const _totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
            _hoennAvailMap[key] = _ajaxAvail || _totalQty > 0;
            const idx = _hoennProductsList.findIndex(x => x.url === url);
            const entry = { title: p.title, img, avail: _hoennAvailMap[key], price, url, featured };
            if (idx >= 0) _hoennProductsList[idx] = entry; else _hoennProductsList.push(entry);
          });
          _applyFeaturedImages(_hoennProductsList, _hoennImgMap, POKE.GEN3);
          renderGrid();
          updateHeroImages();
          break;
        } catch {}
      }
    })();
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 8) {
    buildGalarMapFromLiquid();
    renderContent();
    renderGmaxSection();
    updateHeroImages();
    (async () => {
      for (const h of ['galar', 'gen-8', 'generation-8', 'galar-region', 'pokemon-galar']) {
        try {
          let galarAll = [];
          for (let pg = 1; pg <= 10; pg++) {
            const r = await fetch(`/collections/${h}/products.json?limit=250&page=${pg}&sort_by=title`);
            if (!r.ok) break;
            const { products = [] } = await r.json();
            galarAll = galarAll.concat(products);
            if (products.length < 250) break;
          }
          if (!galarAll.length) continue;
          _sortProducts(galarAll).forEach(p => {
            const key = p.title.toLowerCase().trim();
            const img = p.images && p.images[0] ? p.images[0].src : null;
            const price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
            const url = `/products/${p.handle}`;
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
            if (img && !_galarImgMap[key]) _galarImgMap[key] = img;
            if (price) _galarPriceMap[key] = price;
            if (!_galarUrlMap[key]) _galarUrlMap[key] = url;
            const _ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
            const _totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
            _galarAvailMap[key] = _ajaxAvail || _totalQty > 0;
            const _numMatch = p.title.match(/n°\s*(\d+)/i);
            if (_numMatch) {
              const nk = 'n°' + _numMatch[1];
              if (img && !_galarImgMap[nk]) _galarImgMap[nk] = img;
              if (!_galarPriceMap[nk] && price) _galarPriceMap[nk] = price;
              if (!_galarUrlMap[nk]) _galarUrlMap[nk] = url;
              if (_galarAvailMap[nk] === undefined) _galarAvailMap[nk] = _ajaxAvail || _totalQty > 0;
            }
            const idx = _galarProductsList.findIndex(x => x.url === url);
            const entry = { title: p.title, img, avail: _galarAvailMap[key], price, url, featured };
            if (idx >= 0) _galarProductsList[idx] = entry; else _galarProductsList.push(entry);
          });
          const _galarGenTmp = POKE.genFigures(8).map(f => ({ id: f.num, name: f.name, types: [] }));
          _applyFeaturedImages(_galarProductsList, _galarImgMap, _galarGenTmp);
          renderGrid();
          renderGmaxSection();
          updateHeroImages();
          break;
        } catch {}
      }
    })();
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 7) {
    buildAlolaMapFromLiquid();
    renderContent();
    updateHeroImages();
    (async () => {
      for (const h of ['alola', 'gen-7', 'generation-7', 'alola-region', 'pokemon-alola']) {
        try {
          let alolaAll = [];
          for (let pg = 1; pg <= 10; pg++) {
            const r = await fetch(`/collections/${h}/products.json?limit=250&page=${pg}&sort_by=title`);
            if (!r.ok) break;
            const { products = [] } = await r.json();
            alolaAll = alolaAll.concat(products);
            if (products.length < 250) break;
          }
          if (!alolaAll.length) continue;
          _sortProducts(alolaAll).forEach(p => {
            const key = p.title.toLowerCase().trim();
            const img = p.images && p.images[0] ? p.images[0].src : null;
            const price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
            const url = `/products/${p.handle}`;
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
            if (img && !_alolaImgMap[key]) _alolaImgMap[key] = img;
            if (price) _alolaPriceMap[key] = price;
            if (!_alolaUrlMap[key]) _alolaUrlMap[key] = url;
            const _ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
            const _totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
            _alolaAvailMap[key] = _ajaxAvail || _totalQty > 0;
            const _numMatch = p.title.match(/n°\s*(\d+)/i);
            if (_numMatch) {
              const nk = 'n°' + _numMatch[1];
              if (img && !_alolaImgMap[nk]) _alolaImgMap[nk] = img;
              if (!_alolaPriceMap[nk] && price) _alolaPriceMap[nk] = price;
              if (!_alolaUrlMap[nk]) _alolaUrlMap[nk] = url;
              if (_alolaAvailMap[nk] === undefined) _alolaAvailMap[nk] = _ajaxAvail || _totalQty > 0;
            }
            const idx = _alolaProductsList.findIndex(x => x.url === url);
            const entry = { title: p.title, img, avail: _alolaAvailMap[key], price, url, featured };
            if (idx >= 0) _alolaProductsList[idx] = entry; else _alolaProductsList.push(entry);
          });
          const _alolaGenTmp = POKE.genFigures(7).map(f => ({ id: f.num, name: f.name, types: [] }));
          _applyFeaturedImages(_alolaProductsList, _alolaImgMap, _alolaGenTmp);
          renderGrid();
          updateHeroImages();
          break;
        } catch {}
      }
    })();
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 4) {
    buildSinnohMapFromLiquid();
    renderContent();
    updateHeroImages();
    (async () => {
      for (const h of ['mypokea-decouvrez-toutes-les-finger-puppet-pokemon-kids-de-la-region-de-sinnoh', 'sinnoh', 'gen-4', 'generation-4', 'sinnoh-region', 'pokemon-sinnoh']) {
        try {
          let all = [];
          for (let pg = 1; pg <= 10; pg++) {
            const r = await fetch(`/collections/${h}/products.json?limit=250&page=${pg}&sort_by=title`);
            if (!r.ok) break;
            const { products = [] } = await r.json();
            all = all.concat(products);
            if (products.length < 250) break;
          }
          if (!all.length) continue;
          _sortProducts(all).forEach(p => {
            const key = p.title.toLowerCase().trim();
            const img = p.images && p.images[0] ? p.images[0].src : null;
            const price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
            const url = `/products/${p.handle}`;
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
            if (img && !_sinnohImgMap[key]) _sinnohImgMap[key] = img;
            if (price) _sinnohPriceMap[key] = price;
            if (!_sinnohUrlMap[key]) _sinnohUrlMap[key] = url;
            const _ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
            const _totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
            _sinnohAvailMap[key] = _ajaxAvail || _totalQty > 0;
            const _numMatch = p.title.match(/n°\s*(\d+)/i);
            if (_numMatch) {
              const nk = 'n°' + _numMatch[1];
              if (img && !_sinnohImgMap[nk]) _sinnohImgMap[nk] = img;
              if (!_sinnohPriceMap[nk] && price) _sinnohPriceMap[nk] = price;
              if (!_sinnohUrlMap[nk]) _sinnohUrlMap[nk] = url;
              if (_sinnohAvailMap[nk] === undefined) _sinnohAvailMap[nk] = _ajaxAvail || _totalQty > 0;
            }
            const idx = _sinnohProductsList.findIndex(x => x.url === url);
            const entry = { title: p.title, img, avail: _sinnohAvailMap[key], price, url, featured };
            if (idx >= 0) _sinnohProductsList[idx] = entry; else _sinnohProductsList.push(entry);
          });
          const _s4n = {};
          POKE.genFigures(4).forEach(f => { _s4n[f.num] = f.name.toLowerCase().trim(); });
          Object.keys(_sinnohImgMap).forEach(k => {
            const m = k.match(/n[°º]\s*(\d+)/i);
            if (!m) return;
            const frName = _s4n[parseInt(m[1], 10)];
            if (!frName) return;
            if (!_sinnohImgMap[frName]) _sinnohImgMap[frName] = _sinnohImgMap[k];
            if (_sinnohUrlMap[k] && !_sinnohUrlMap[frName]) _sinnohUrlMap[frName] = _sinnohUrlMap[k];
            if (_sinnohAvailMap[k] !== undefined && _sinnohAvailMap[frName] === undefined) _sinnohAvailMap[frName] = _sinnohAvailMap[k];
            if (_sinnohPriceMap[k] && !_sinnohPriceMap[frName]) _sinnohPriceMap[frName] = _sinnohPriceMap[k];
          });
          const _genTmp4 = POKE.genFigures(4).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG }));
          _applyFeaturedImages(_sinnohProductsList, _sinnohImgMap, _genTmp4);
          renderGrid();
          updateHeroImages();
          break;
        } catch {}
      }
    })();
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 5) {
    buildUnysMapFromLiquid();
    renderContent();
    updateHeroImages();
    (async () => {
      for (const h of ['unys', 'gen-5', 'generation-5', 'unova', 'pokemon-unova']) {
        try {
          let all = [];
          for (let pg = 1; pg <= 10; pg++) {
            const r = await fetch(`/collections/${h}/products.json?limit=250&page=${pg}&sort_by=title`);
            if (!r.ok) break;
            const { products = [] } = await r.json();
            all = all.concat(products);
            if (products.length < 250) break;
          }
          if (!all.length) continue;
          _sortProducts(all).forEach(p => {
            const key = p.title.toLowerCase().trim();
            const img = p.images && p.images[0] ? p.images[0].src : null;
            const price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
            const url = `/products/${p.handle}`;
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
            if (img && !_unysImgMap[key]) _unysImgMap[key] = img;
            if (price) _unysPriceMap[key] = price;
            if (!_unysUrlMap[key]) _unysUrlMap[key] = url;
            const _ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
            const _totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
            _unysAvailMap[key] = _ajaxAvail || _totalQty > 0;
            const _numMatch = p.title.match(/n°\s*(\d+)/i);
            if (_numMatch) {
              const nk = 'n°' + _numMatch[1];
              if (img && !_unysImgMap[nk]) _unysImgMap[nk] = img;
              if (!_unysPriceMap[nk] && price) _unysPriceMap[nk] = price;
              if (!_unysUrlMap[nk]) _unysUrlMap[nk] = url;
              if (_unysAvailMap[nk] === undefined) _unysAvailMap[nk] = _ajaxAvail || _totalQty > 0;
            }
            const idx = _unysProductsList.findIndex(x => x.url === url);
            const entry = { title: p.title, img, avail: _unysAvailMap[key], price, url, featured };
            if (idx >= 0) _unysProductsList[idx] = entry; else _unysProductsList.push(entry);
          });
          const _genTmp5 = POKE.genFigures(5).map(f => ({ id: f.num, name: f.name, types: [] }));
          _applyFeaturedImages(_unysProductsList, _unysImgMap, _genTmp5);
          renderGrid();
          updateHeroImages();
          break;
        } catch {}
      }
    })();
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 6) {
    buildKalosMapFromLiquid();
    renderContent();
    updateHeroImages();
    (async () => {
      for (const h of ['kalos', 'gen-6', 'generation-6', 'kalos-region', 'pokemon-kalos']) {
        try {
          let all = [];
          for (let pg = 1; pg <= 10; pg++) {
            const r = await fetch(`/collections/${h}/products.json?limit=250&page=${pg}&sort_by=title`);
            if (!r.ok) break;
            const { products = [] } = await r.json();
            all = all.concat(products);
            if (products.length < 250) break;
          }
          if (!all.length) continue;
          _sortProducts(all).forEach(p => {
            const key = p.title.toLowerCase().trim();
            const img = p.images && p.images[0] ? p.images[0].src : null;
            const price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
            const url = `/products/${p.handle}`;
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
            if (img && !_kalosImgMap[key]) _kalosImgMap[key] = img;
            if (price) _kalosPriceMap[key] = price;
            if (!_kalosUrlMap[key]) _kalosUrlMap[key] = url;
            const _ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
            const _totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
            _kalosAvailMap[key] = _ajaxAvail || _totalQty > 0;
            const _numMatch = p.title.match(/n°\s*(\d+)/i);
            if (_numMatch) {
              const nk = 'n°' + _numMatch[1];
              if (img && !_kalosImgMap[nk]) _kalosImgMap[nk] = img;
              if (!_kalosPriceMap[nk] && price) _kalosPriceMap[nk] = price;
              if (!_kalosUrlMap[nk]) _kalosUrlMap[nk] = url;
              if (_kalosAvailMap[nk] === undefined) _kalosAvailMap[nk] = _ajaxAvail || _totalQty > 0;
            }
            const idx = _kalosProductsList.findIndex(x => x.url === url);
            const entry = { title: p.title, img, avail: _kalosAvailMap[key], price, url, featured };
            if (idx >= 0) _kalosProductsList[idx] = entry; else _kalosProductsList.push(entry);
          });
          const _genTmp6 = POKE.genFigures(6).map(f => ({ id: f.num, name: f.name, types: [] }));
          _applyFeaturedImages(_kalosProductsList, _kalosImgMap, _genTmp6);
          renderGrid();
          updateHeroImages();
          break;
        } catch {}
      }
    })();
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  if (GEN_NUM === 9) {
    buildPaldeaMapFromLiquid();
    renderContent();
    updateHeroImages();
    (async () => {
      for (const h of ['paldea', 'gen-9', 'generation-9', 'paldea-region', 'pokemon-paldea']) {
        try {
          let all = [];
          for (let pg = 1; pg <= 10; pg++) {
            const r = await fetch(`/collections/${h}/products.json?limit=250&page=${pg}&sort_by=title`);
            if (!r.ok) break;
            const { products = [] } = await r.json();
            all = all.concat(products);
            if (products.length < 250) break;
          }
          if (!all.length) continue;
          _sortProducts(all).forEach(p => {
            const key = p.title.toLowerCase().trim();
            const img = p.images && p.images[0] ? p.images[0].src : null;
            const price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
            const url = `/products/${p.handle}`;
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const featured = tags.some(t => t.trim().toLowerCase() === 'featured');
            if (img && !_paldeaImgMap[key]) _paldeaImgMap[key] = img;
            if (price) _paldeaPriceMap[key] = price;
            if (!_paldeaUrlMap[key]) _paldeaUrlMap[key] = url;
            const _ajaxAvail = p.variants ? p.variants.some(v => v.available) : false;
            const _totalQty  = p.variants ? p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0) : 0;
            _paldeaAvailMap[key] = _ajaxAvail || _totalQty > 0;
            const _numMatch = p.title.match(/n°\s*(\d+)/i);
            if (_numMatch) {
              const nk = 'n°' + _numMatch[1];
              if (img && !_paldeaImgMap[nk]) _paldeaImgMap[nk] = img;
              if (!_paldeaPriceMap[nk] && price) _paldeaPriceMap[nk] = price;
              if (!_paldeaUrlMap[nk]) _paldeaUrlMap[nk] = url;
              if (_paldeaAvailMap[nk] === undefined) _paldeaAvailMap[nk] = _ajaxAvail || _totalQty > 0;
            }
            const idx = _paldeaProductsList.findIndex(x => x.url === url);
            const entry = { title: p.title, img, avail: _paldeaAvailMap[key], price, url, featured };
            if (idx >= 0) _paldeaProductsList[idx] = entry; else _paldeaProductsList.push(entry);
          });
          const _genTmp9 = POKE.genFigures(9).map(f => ({ id: f.num, name: f.name, types: [] }));
          _applyFeaturedImages(_paldeaProductsList, _paldeaImgMap, _genTmp9);
          renderGrid();
          updateHeroImages();
          break;
        } catch {}
      }
    })();
    _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
    return;
  }

  renderContent();
  _shopifyAjaxFetch('dresseurs', {}, {}, {}, _dresseursProductsList, {}, renderTrainers);
});

function renderGmaxSection() {
  const gmaxCat = (POKE.SPECIALS || []).find(c => c.id === 'gmax');
  if (!gmaxCat) return;
  const root = document.getElementById('gen-content');
  if (!root) return;
  const old = document.getElementById('gmax-section');
  if (old) old.remove();

  // Combine gigamax collection (priorité) + liste galar (fallback)
  const gmaxRaw = (window.GIGAMAX_PRODUCTS_RAW || []).map(p => ({
    title: p.t, img: p.i, avail: p.a !== false, price: p.p || null, url: p.u || null
  }));
  const allGmaxProds = [...gmaxRaw, ...(window._galarProductsList || [])];

  const tiles = gmaxCat.figures.map(fig => {
    const nameWords = fig.n.toLowerCase().split(' ').filter(w => w.length > 2);
    const prod = allGmaxProds.find(p =>
      p.title && nameWords.every(w => p.title.toLowerCase().includes(w))
    );
    const img   = prod ? prod.img   : null;
    const avail = prod ? prod.avail !== false : false;
    const price = prod ? prod.price : null;
    const url   = prod ? prod.url   : null;
    const tag   = url ? 'a' : 'div';
    const href  = url ? `href="${url}"` : '';
    const oos   = !prod || !avail;
    return `
      <${tag} class="poke-tile${oos ? ' oos' : ''}" ${href} title="${fig.n}">
        <div class="poke-img-wrap">
          <span class="poke-num" style="color:var(--berry)">G-Max</span>
          ${img ? `<img src="${img}" alt="${_altStd(fig.n, null)}" loading="lazy" draggable="false">` : `<div style="width:72px;height:72px"></div>`}
        </div>
        <div class="poke-info">
          <div class="poke-name">${fig.n}</div>
          <div class="poke-types-mini"></div>
        </div>
        <div class="poke-foot">
          <span class="poke-price">${price ? 'dès ' + price.toFixed(2).replace('.', ',') + ' €' : '—'}</span>
          ${oos ? `<span class="rupture">Rupture</span>` : `<span class="poke-add-btn" aria-hidden="true">+</span>`}
        </div>
      </${tag}>
    `;
  }).join('');

  const section = document.createElement('section');
  section.id = 'gmax-section';
  section.innerHTML = `
    <h2 style="font-size:clamp(18px,2.2vw,26px);margin:40px 0 16px;padding-bottom:10px;border-bottom:2px solid var(--berry);color:var(--berry)">
      Gigamax <span style="font-size:13px;font-weight:400;opacity:0.7">— 12 figurines série G-Max · format +40 %</span>
    </h2>
    <div class="dex-grid">${tiles}</div>
  `;
  root.appendChild(section);
}

var GEN_PAGE_HANDLE = { 1: 'pokedex-kanto', 2: 'pokedex-johto', 3: 'pokedex-hoenn', 4: 'pokedex-sinnoh', 5: 'pokedex-unys', 6: 'pokedex-kalos', 7: 'pokedex-alola', 8: 'pokedex-galar', 9: 'pokedex-paldea' };
function genPageUrl(gen) { return GEN_PAGE_HANDLE[gen] ? '/pages/' + GEN_PAGE_HANDLE[gen] : '/pages/pokedex?gen=' + gen; }

function renderGenStrip() {
  const root = document.getElementById("gen-strip");
  root.innerHTML = POKE.GENERATIONS.map(g => `
    <a class="gen-strip-item ${g.gen === GEN_NUM ? 'active' : ''} ${g.upcoming ? 'upcoming' : ''}"
       href="${g.upcoming ? '#' : genPageUrl(g.gen)}">
      <span class="n">${String(g.gen).padStart(2,'0')}</span>
      ${g.name}
      <span class="jp" style="font-size:11px; opacity:0.6;">${g.kanji}</span>
    </a>
  `).join("");
}

function renderContent() {
  const root = document.getElementById("gen-content");
  const gen = POKE.GENERATIONS.find(g => g.gen === GEN_NUM);
  document.getElementById("crumb-gen").textContent = `Génération ${gen.gen} — ${gen.name}`;
  document.title = gen.metaTitle || `Pokédex ${gen.name} — MyPokea`;
  if (gen.metaDesc) {
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement('meta'); m.setAttribute('name', 'description'); document.head.appendChild(m); }
    m.setAttribute('content', gen.metaDesc);
  }

  if (gen.upcoming) {
    root.innerHTML = `
      <div class="gen-placeholder">
        <h2>Bientôt 2026</h2>
        <p>La génération 10 sera annoncée fin 2026. Inscris-toi à la newsletter pour être prévenu·e dès l'ouverture des pré-commandes.</p>
        <a href="/pages/pokedex-kanto" class="btn btn-primary">← Retour à Kanto</a>
      </div>
    `;
    return;
  }

  // Hero
  root.innerHTML = `
    <section class="gen-hero" style="--gen-color: ${gen.color}; --gen-deep: ${gen.deep || gen.color};">
      <div class="gen-hero-info">
        <span class="gen-hero-tag">Génération · ${gen.years}</span>
        <h1 class="gen-hero-title"><span class="gen-hero-num">${String(gen.gen).padStart(2,'0')}</span>${gen.name}</h1>
        <p class="gen-hero-blurb">${gen.blurb}</p>
        <div class="gen-hero-stats">
          <div><b>${gen.count}</b><span>Pokémon</span></div>
          <div><b>#${String(gen.range[0]).padStart(3,'0')} → #${String(gen.range[1]).padStart(3,'0')}</b><span>Plage Pokédex</span></div>
          <div><b>${gen.stockPct}%</b><span>en stock</span></div>
        </div>
        <div class="gen-progress">
          <span class="gen-progress-lbl"><strong id="prog-num">0</strong> / ${gen.count} dans ton sac</span>
          <div class="gen-progress-bar"><div id="prog-bar" style="width: 0%;"></div></div>
          <span class="gen-progress-lbl" id="prog-pct">0 %</span>
        </div>
      </div>
      <div class="gen-hero-visual">
        <span class="gen-hero-kanji" aria-hidden="true">${gen.kanji}</span>
        <i class="gen-hero-shape ghs-star" aria-hidden="true"></i>
        <i class="gen-hero-shape ghs-ring" aria-hidden="true"></i>
        <i class="gen-hero-shape ghs-plus" aria-hidden="true"></i>
        <i class="gen-hero-shape ghs-diamond" aria-hidden="true"></i>
        <div class="gen-hero-discs">
          ${(GEN_STARTERS[gen.gen] || []).map((id, discIdx) => {
            const genArr = gen.gen === 1 ? POKE.GEN1 : gen.gen === 2 ? POKE.GEN2 : gen.gen === 3 ? POKE.GEN3 : null;
            const po = genArr ? genArr.find(p => p.id === id) : null;
            const name = po ? po.name : '';
            return `<a class="gen-disc" id="hero-disc-${discIdx}" href="#"><img src="${GENERIC_REAL_FALLBACK_IMG}" alt="${_altStd(name, id)}" loading="lazy"></a>`;
          }).join('')}
        </div>
      </div>
    </section>
  `;

  if (gen.gen !== 1) {
    root.insertAdjacentHTML("beforeend", `
      <div class="dex-filters">
        <label class="dex-search">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg>
          <input type="search" id="dex-search" placeholder="Chercher dans ${gen.name} (n° national)" value="${state.q}">
        </label>
        <div class="dex-segment" role="tablist">
          <button data-seg="all" class="on">Tout</button>
          <button data-seg="stock">En stock</button>
        </div>
        <select class="dex-sort" id="dex-sort">
          <option value="num-asc">N° Pokédex ↑</option>
          <option value="num-desc">N° Pokédex ↓</option>
          <option value="price-asc">Prix croissant</option>
          <option value="price-desc">Prix décroissant</option>
        </select>
      </div>
      <div class="dex-types" id="dex-types"></div>
      <div class="dex-stats-strip" id="dex-stats"></div>
      <div class="dex-grid" id="dex-grid"></div>
      <div id="dex-trainers"></div>
    `);
    renderTypeChips();
    renderGrid();
    renderTrainers();
    bindFilters();
    bindDexDragSelect(document.getElementById("dex-grid"));
    return;
  }

  // Filters + grid for Gen 1
  root.insertAdjacentHTML("beforeend", `
    <div class="dex-filters">
      <label class="dex-search">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg>
        <input type="search" id="dex-search" placeholder="Chercher dans Kanto (Pikachu, Évoli…)" value="${state.q}">
      </label>
      <div class="dex-segment" role="tablist">
        <button data-seg="all" class="on">Tout</button>
        <button data-seg="stock">En stock</button>
      </div>
      <select class="dex-sort" id="dex-sort">
        <option value="num-asc">N° Pokédex ↑</option>
        <option value="num-desc">N° Pokédex ↓</option>
        <option value="name-asc">Nom A → Z</option>
        <option value="price-asc">Prix croissant</option>
        <option value="price-desc">Prix décroissant</option>
      </select>
      <button type="button" class="dex-sort" id="pika-mode-toggle">Pikachu : ${state.pikaSingle ? 'carte unique' : 'formes multiples'}</button>
    </div>
    <div class="dex-types" id="dex-types"></div>
    <div class="dex-stats-strip" id="dex-stats"></div>
    <div class="dex-grid" id="dex-grid"></div>
    <div id="dex-trainers"></div>
  `);

  renderTypeChips();
  if (GEN_NUM === 1 && !window._kantoReadyFromCache) {
    document.getElementById('dex-grid').innerHTML = Array.from({length: 151}, () =>
      '<div style="height:150px;border-radius:var(--r-3,10px);background:var(--surface-2,#e0e0e0);opacity:0.5"></div>'
    ).join('');
  } else {
    renderGrid();
  }
  renderTrainers();
  bindFilters();
  renderExpandFab();
}

function renderTrainers() {
  const root = document.getElementById("dex-trainers");
  if (!root) return;
  const products = window._dresseursProductsList || [];
  if (!products.length) { root.innerHTML = ""; return; }
  const ZOOM_BTN = `<button type="button" class="poke-img-zoom" aria-label="Agrandir"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg></button>`;
  root.innerHTML = `
    <div class="dex-subhead">
      <span class="eyebrow">Dresseurs · トレーナー</span>
      <a href="/collections/dresseurs">Voir toute la collection &rarr;</a>
    </div>
    <div class="dex-grid">
      ${products.map((p, i) => {
        const name = (p.title.match(/(?:trainer|dresseur|dresseuse)\s*[—–-]\s*(.+)/i) || p.title.match(/^(.+?)\s*[—–-]/i) || [])[1]?.trim() || p.title;
        const oos  = p.avail === false;
        const picked = hasPick(`tr-${i}`);
        return `<div class="poke-tile trainer-tile${oos ? ' oos' : ''}${picked ? ' picked' : ''}" data-tr-idx="${i}"
             title="${name} · ${p.price ? p.price.toFixed(2).replace('.', ',') + ' €' : 'Rupture'}">
          <span class="poke-pick-badge" aria-hidden="true">${picked ? '1' : ''}</span>
          <div class="poke-img-wrap">
            ${p.img ? `<img src="${p.img}" alt="${_altStd(name, null)}" loading="lazy" draggable="false">` : `<div style="flex:1"></div>`}
            ${!oos ? ZOOM_BTN : ''}
          </div>
          <div class="poke-info">
            <div class="poke-name">${name}</div>
          </div>
          <div class="poke-foot">
            <span class="poke-price">${p.price ? p.price.toFixed(2).replace('.', ',') + ' €' : '—'}</span>
            ${oos ? '<span class="poke-oos-label">Rupture</span>' : '<span class="poke-add-btn" aria-hidden="true">+</span>'}
          </div>
        </div>`;
      }).join("")}
    </div>
  `;
  root.querySelectorAll(".trainer-tile").forEach(tile => {
    const i = parseInt(tile.dataset.trIdx, 10);
    const p = products[i];
    if (!p) return;
    const name = (p.title.match(/(?:trainer|dresseur|dresseuse)\s*[—–-]\s*(.+)/i) || p.title.match(/^(.+?)\s*[—–-]/i) || [])[1]?.trim() || p.title;
    tile.querySelector(".poke-img-zoom")?.addEventListener("click", e => {
      e.stopPropagation();
      openZoom(p.img, name, p.price, p.url);
    });
    tile.addEventListener("click", e => {
      if (e.target.closest(".poke-img-zoom")) return;
      if (tile.classList.contains("oos")) return;
      const key = `tr-${i}`;
      togglePick({ key, num: 0, name, variant: 'Dresseur', price: p.price || 0, image: p.img || '', url: p.url });
      tile.classList.toggle("picked", hasPick(key));
    });
  });
}
function renderTypeChips() {
  const root = document.getElementById("dex-types");
  if (!root) return;
  // Types disponibles uniquement pour Kanto/Johto/Hoenn (seules générations avec
  // des données de type dans data.js) — rien à afficher au-delà.
  const genData = GEN_NUM === 1 ? POKE.GEN1 : GEN_NUM === 2 ? POKE.GEN2 : GEN_NUM === 3 ? POKE.GEN3 : null;
  if (!genData) { root.innerHTML = ""; return; }
  const used = new Set();
  genData.forEach(p => p.types.forEach(t => used.add(t)));
  const types = [...used].sort();
  root.innerHTML = types.map(t => {
    const T = POKE.TYPES[t];
    const on = state.types.has(t) ? " on" : "";
    return `<button class="dex-type${on}" data-type="${t}" style="--tc: ${T.color}; --ti: ${T.ink};">${T.label}</button>`;
  }).join("");
  root.querySelectorAll(".dex-type").forEach(b => {
    b.onclick = () => {
      const t = b.dataset.type;
      if (state.types.has(t)) { state.types.delete(t); b.classList.remove("on"); }
      else { state.types.add(t); b.classList.add("on"); }
      renderGrid();
    };
  });
}

function _deAccent(s) {
  return s.toLowerCase().trim()
    .replace(/♀/g, ' femelle').replace(/♂/g, ' male')
    .replace(/[—–]/g, ' ')
    .replace(/\./g, '')
    .replace(/œ/g, 'oe').replace(/æ/g, 'ae')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ').trim();
}
function _lev(a, b) {
  if (Math.abs(a.length - b.length) > 2) return 99;
  const d = Array.from({length: a.length + 1}, (_, i) => [i]);
  for (let j = 0; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++)
    for (let j = 1; j <= b.length; j++)
      d[i][j] = a[i-1] === b[j-1] ? d[i-1][j-1] : 1 + Math.min(d[i-1][j], d[i][j-1], d[i-1][j-1]);
  return d[a.length][b.length];
}
function _matchesPoke(productTitle, pokeName) {
  const t = productTitle;
  const n = pokeName.toLowerCase().trim();
  // Noms N° (gens sans noms français) : cherche le numéro dans le titre
  if (/^n[°º]/i.test(n)) {
    const num = n.replace(/^n[°º]\s*0*/i, '');
    return new RegExp(`n[°º]\\s*0*${num}(?!\\d)`, 'i').test(t);
  }
  const nNorm  = _deAccent(n);
  const words  = t.toLowerCase().split(/[^a-zÀ-ž0-9]+/).filter(Boolean);
  if (words.includes(n)) return true;
  const tNorm     = _deAccent(t);
  const wordsNorm = tNorm.split(/[^a-z0-9]+/).filter(Boolean);
  if (wordsNorm.includes(nNorm)) return true;
  // noms avec trait d'union (Ho-Oh) : normalise le tiret en espace pour comparaison de phrase
  if (nNorm.includes('-')) {
    const nSpaced = nNorm.replace(/-+/g, ' ');
    const tSpaced = tNorm.replace(/-+/g, ' ');
    if (tSpaced.includes(nSpaced)) return true;
  }
  // noms multi-mots (M. Mime → "m mime") : cherche la phrase dans le titre normalisé
  if (nNorm.includes(' ')) {
    if (tNorm.includes(nNorm)) return true;
    // fallback : les mots significatifs (>2 car) sont tous présents (ex: "m mime" → "mime" dans "mr mime")
    const sigWords = nNorm.split(' ').filter(w => w.length > 2);
    if (sigWords.length && sigWords.every(w => wordsNorm.includes(w))) return true;
  }
  // Tolérance 1 caractère : couvre les fautes de frappe dans Shopify (ex: "Cisayox" vs "Cizayox")
  // Exclut les cas où un mot est strictement un préfixe de l'autre (ex: "rattata" ≠ "rattatac")
  if (nNorm.length >= 6) {
    if (wordsNorm.some(w => {
      if (Math.abs(w.length - nNorm.length) > 1) return false;
      const shorter = w.length <= nNorm.length ? w : nNorm;
      const longer  = w.length <= nNorm.length ? nNorm : w;
      if (longer.startsWith(shorter)) return false;
      return _lev(w, nNorm) <= 1;
    })) return true;
  }
  return false;
}

function getFormsForId(id) {
  const poke = POKE.GEN1.find(x => x.id === id);
  if (!poke) return POKE.forms(id);

  // Build from real Shopify products when available
  if (window._kantoProductsList && _kantoProductsList.length) {
    const matches = _kantoProductsList.filter(p => _matchesPoke(p.title, poke.name))
      .sort((a, b) => {
        const aT = _isTransparent(a.title) ? 1 : 0, bT = _isTransparent(b.title) ? 1 : 0;
        if (aT !== bT) return aT - bT;
        const aFeat = a.featured ? 0 : 1; const bFeat = b.featured ? 0 : 1;
        if (aFeat !== bFeat) return aFeat - bFeat;
        return (_isSpecialForm(a.title) ? 1 : 0) - (_isSpecialForm(b.title) ? 1 : 0);
      });
    if (matches.length > 0) {
      return matches.map((prod, i) => {
        const cleanLabel = prod.title
          .replace(/^figurine\s+pok[eé]mon\s*(kids\s*)?(finger\s*puppet\s*)?/i, '')
          .replace(/\s*n°\s*\d+\s*$/i, '')
          .trim() || prod.title;
        return {
        key:     `kp-${id}-${i}`,
        num:     id,
        type:    'kids',
        name:    poke.name,
        label:   cleanLabel,
        badge:   'Kids',
        tag:     'Figurine Pokémon Kids Bandai',
        color:   'var(--accent)',
        art:     prod.img || poke.img,
        sprite:  prod.img || poke.sprite,
        shiny:   false,
        inStock: prod.avail !== false,
        price:   prod.price ?? 0,
        stock:   prod.avail ? 1 : 0,
        url:     prod.url || null,
        };
      });
    }
  }

  // Fallback: static POKE.forms with real availability patched in
  return POKE.forms(id).map(f => {
    if (f.type !== 'kids') return f;
    const realImg   = kantoImg(poke.name);
    const realAvail = kantoAvail(poke.name);
    const realPrice = kantoPrice(poke.name);
    return { ...f,
      art:     realImg   || f.art,
      inStock: realAvail !== undefined ? realAvail : f.inStock,
      price:   realPrice ?? f.price,
      stock:   realAvail !== undefined ? (realAvail ? 1 : 0) : f.stock,
    };
  });
}

function getFormsForGen23(id) {
  const genData = GEN_NUM === 2 ? POKE.GEN2 : GEN_NUM === 3 ? POKE.GEN3 : POKE.genFigures(GEN_NUM).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG }));
  const productsList = GEN_NUM === 2 ? window._johtoProductsList : GEN_NUM === 3 ? window._hoennProductsList : GEN_NUM === 4 ? window._sinnohProductsList : GEN_NUM === 5 ? window._unysProductsList : GEN_NUM === 6 ? window._kalosProductsList : GEN_NUM === 7 ? window._alolaProductsList : GEN_NUM === 8 ? window._galarProductsList : GEN_NUM === 9 ? window._paldeaProductsList : [];
  const poke = genData ? genData.find(x => x.id === id) : null;
  if (!poke || !productsList || !productsList.length) return [];
  const _pokeFrName = poke._frName || poke.name;
  const matches = productsList
    .filter(p => _matchesPoke(p.title, _pokeFrName))
    .sort((a, b) => {
      const aT = _isTransparent(a.title) ? 1 : 0, bT = _isTransparent(b.title) ? 1 : 0;
      if (aT !== bT) return aT - bT;
      if ((a.featured ? 0 : 1) !== (b.featured ? 0 : 1)) return (a.featured ? 0 : 1) - (b.featured ? 0 : 1);
      return (_isSpecialForm(a.title) ? 1 : 0) - (_isSpecialForm(b.title) ? 1 : 0);
    });
  return matches.map((prod, i) => ({
    key:     `gen${GEN_NUM}-${id}-${i}`,
    num:     id,
    type:    'kids',
    name:    poke.name,
    label:   prod.title,
    badge:   'Kids',
    tag:     'Figurine Pokémon Kids Bandai',
    color:   'var(--accent)',
    art:     prod.img || poke.img,
    sprite:  prod.img || poke.sprite,
    shiny:   false,
    inStock: prod.avail !== false,
    price:   prod.price ?? 0,
    stock:   prod.avail ? 1 : 0,
    url:     prod.url || null,
  }));
}

function _kantoFind(map, name) {
  if (!map) return undefined;
  const n = name.toLowerCase().trim();
  if (n in map) return map[n];
  const nNorm = _deAccent(n);
  // ♀/♂ handling: strip symbol for word matching, prefer keys that also contain it
  const gSym = n.match(/[♀♂]/)?.[0] ?? null;
  if (gSym) {
    const nBase = _deAccent(n.replace(gSym, '').replace(/\s+/g, ' ').trim());
    let fallback;
    for (const [k, v] of Object.entries(map)) {
      const kp = k.replace(/\s+avec\s+.*/i, '');
      const wordsNorm = _deAccent(kp).split(/[^a-z0-9]+/).filter(Boolean);
      if (wordsNorm.includes(nBase)) {
        if (k.includes(gSym)) return v;
        if (fallback === undefined) fallback = v;
      }
    }
    return fallback;
  }
  for (const [k, v] of Object.entries(map)) {
    // Ignore secondary Pokémon listed after "avec" to avoid image contamination
    const kp = k.replace(/\s+avec\s+.*/i, '');
    const words = kp.toLowerCase().split(/[^a-zÀ-ž0-9]+/).filter(Boolean);
    if (words.includes(n)) return v;
    const kNorm = _deAccent(kp);
    const wordsNorm = kNorm.split(/[^a-z0-9]+/).filter(Boolean);
    if (wordsNorm.includes(nNorm)) return v;
    if (nNorm.includes(' ') && kNorm.includes(nNorm)) return v;
    if (nNorm.includes('-')) {
      const nSpaced = nNorm.replace(/-+/g, ' ');
      const kSpaced = kNorm.replace(/-+/g, ' ');
      if (kSpaced.includes(nSpaced)) return v;
    }
    if (nNorm.includes(' ')) {
      const sigWords = nNorm.split(' ').filter(w => w.length > 2);
      if (sigWords.length && sigWords.every(w => wordsNorm.includes(w))) return v;
    }
  }
  return undefined;
}
function kantoImg(name)   { return _kantoBestFind(window._kantoImgMap,   name) ?? null; }
function kantoAvail(name) {
  const map = window._kantoAvailMap;
  if (!map) return undefined;
  const n = name.toLowerCase().trim();
  if (n in map) return map[n];
  const nNorm = _deAccent(n);
  const gSym = n.match(/[♀♂]/)?.[0] ?? null;
  const nSearch = gSym ? _deAccent(n.replace(gSym, '').trim()) : nNorm;
  let anyMatch = undefined, fallback = undefined;
  for (const [k, v] of Object.entries(map)) {
    const words = _deAccent(k.replace(/\s+avec\s+.*/i, '')).split(/[^a-z0-9]+/).filter(Boolean);
    if (!words.includes(nSearch)) continue;
    if (gSym && !k.includes(gSym)) { if (fallback === undefined) fallback = v; continue; }
    if (v === true) return true;
    anyMatch = false;
  }
  return anyMatch !== undefined ? anyMatch : fallback;
}
function kantoPrice(name) {
  const pm = window._kantoPriceMap, am = window._kantoAvailMap;
  if (!pm) return null;
  const n = name.toLowerCase().trim();
  if (n in pm) return pm[n];
  const nNorm = _deAccent(n);
  const gSym = n.match(/[♀♂]/)?.[0] ?? null;
  const nSearch = gSym ? _deAccent(n.replace(gSym, '').trim()) : nNorm;
  let anyPrice = null, fallbackPrice = null;
  for (const [k, v] of Object.entries(pm)) {
    const words = _deAccent(k.replace(/\s+avec\s+.*/i, '')).split(/[^a-z0-9]+/).filter(Boolean);
    if (!words.includes(nSearch)) continue;
    if (gSym && !k.includes(gSym)) { if (!fallbackPrice) fallbackPrice = v; continue; }
    if (!anyPrice) anyPrice = v;
    if (am && am[k] !== false) return v;
  }
  return anyPrice ?? fallbackPrice;
}
function kantoUrl(name)   { return _kantoBestFind(window._kantoUrlMap,   name) ?? null; }

function johtoImg(name)   { return _kantoFind(window._johtoImgMap,   name) ?? null; }
function johtoAvail(name) { return _kantoFind(window._johtoAvailMap, name); }
function johtoPrice(name) { return _kantoFind(window._johtoPriceMap, name) ?? null; }
function johtoUrl(name)   { return _kantoFind(window._johtoUrlMap,   name) ?? null; }

function hoennImg(name)   { return _kantoFind(window._hoennImgMap,   name) ?? null; }
function hoennAvail(name) { return _kantoFind(window._hoennAvailMap, name); }
function hoennPrice(name) { return _kantoFind(window._hoennPriceMap, name) ?? null; }
function hoennUrl(name)   { return _kantoFind(window._hoennUrlMap,   name) ?? null; }

function alolaImg(name)   { return _kantoFind(window._alolaImgMap,   name) ?? null; }
function alolaAvail(name) { return _kantoFind(window._alolaAvailMap, name); }
function alolaPrice(name) { return _kantoFind(window._alolaPriceMap, name) ?? null; }
function alolaUrl(name)   { return _kantoFind(window._alolaUrlMap,   name) ?? null; }

function galarImg(name)   { return _kantoFind(window._galarImgMap,   name) ?? null; }
function galarAvail(name) { return _kantoFind(window._galarAvailMap, name); }
function galarPrice(name) { return _kantoFind(window._galarPriceMap, name) ?? null; }
function galarUrl(name)   { return _kantoFind(window._galarUrlMap,   name) ?? null; }

function sinnohImg(name)   { return _kantoFind(window._sinnohImgMap,   name) ?? null; }
function sinnohAvail(name) { return _kantoFind(window._sinnohAvailMap, name); }
function sinnohPrice(name) { return _kantoFind(window._sinnohPriceMap, name) ?? null; }
function sinnohUrl(name)   { return _kantoFind(window._sinnohUrlMap,   name) ?? null; }

function unysImg(name)   { return _kantoFind(window._unysImgMap,   name) ?? null; }
function unysAvail(name) { return _kantoFind(window._unysAvailMap, name); }
function unysPrice(name) { return _kantoFind(window._unysPriceMap, name) ?? null; }
function unysUrl(name)   { return _kantoFind(window._unysUrlMap,   name) ?? null; }

function kalosImg(name)   { return _kantoFind(window._kalosImgMap,   name) ?? null; }
function kalosAvail(name) { return _kantoFind(window._kalosAvailMap, name); }
function kalosPrice(name) { return _kantoFind(window._kalosPriceMap, name) ?? null; }
function kalosUrl(name)   { return _kantoFind(window._kalosUrlMap,   name) ?? null; }

function paldeaImg(name)   { return _kantoFind(window._paldeaImgMap,   name) ?? null; }
function paldeaAvail(name) { return _kantoFind(window._paldeaAvailMap, name); }
function paldeaPrice(name) { return _kantoFind(window._paldeaPriceMap, name) ?? null; }
function paldeaUrl(name)   { return _kantoFind(window._paldeaUrlMap,   name) ?? null; }

function _buildGenList(genData, imgFn, availFn, priceFn, availMapKey) {
  const _enMap  = (window.POKE && POKE.POKE_EN_NAMES) || {};
  const _lang   = (() => { try { return localStorage.getItem('mypokea-lang') || 'fr'; } catch { return 'fr'; } })();
  return genData.map(p => {
    const img       = imgFn(p.name) || p.img;
    const realAvail = availFn(p.name);
    const realPrice = priceFn(p.name);
    const base      = POKE.availability(p.id);
    const avail = realAvail !== undefined
      ? { ...base, kids: realAvail, kidsPrice: (realPrice > 0 ? realPrice : null) ?? base.kidsPrice ?? 8.90, kidsStock: realAvail ? 1 : 0 }
      : base;
    const enName = _lang !== 'fr' && _enMap[p.id];
    return { ...p, avail, img, name: enName || p.name, _frName: p.name };
  });
}

function getFilteredSorted() {
  const isGen1 = GEN_NUM === 1;
  const isGen2 = GEN_NUM === 2;
  const isGen3 = GEN_NUM === 3;
  const isGen7 = GEN_NUM === 7;
  const isGen8 = GEN_NUM === 8;

  let list = isGen1
    ? _buildGenList(POKE.GEN1, kantoImg, kantoAvail, kantoPrice, '_kantoAvailMap')
    : isGen2
      ? _buildGenList(POKE.GEN2, johtoImg, johtoAvail, johtoPrice, '_johtoAvailMap')
      : isGen3
        ? _buildGenList(POKE.GEN3, hoennImg, hoennAvail, hoennPrice, '_hoennAvailMap')
        : isGen7
          ? _buildGenList(POKE.genFigures(7).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG })), alolaImg, alolaAvail, alolaPrice, '_alolaAvailMap').filter(p => alolaUrl(p.name) !== null)
          : isGen8
            ? _buildGenList(POKE.genFigures(8).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG })), galarImg, galarAvail, galarPrice, '_galarAvailMap').filter(p => galarUrl(p.name) !== null)
            : GEN_NUM === 4
              ? _buildGenList(POKE.genFigures(4).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG })), sinnohImg, sinnohAvail, sinnohPrice, '_sinnohAvailMap')
              : GEN_NUM === 5
                ? _buildGenList(POKE.genFigures(5).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG })), unysImg, unysAvail, unysPrice, '_unysAvailMap').filter(p => unysUrl(p.name) !== null)
                : GEN_NUM === 6
                  ? _buildGenList(POKE.genFigures(6).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG })), kalosImg, kalosAvail, kalosPrice, '_kalosAvailMap').filter(p => kalosUrl(p.name) !== null)
                  : GEN_NUM === 9
                    ? _buildGenList(POKE.genFigures(9).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG })), paldeaImg, paldeaAvail, paldeaPrice, '_paldeaAvailMap').filter(p => paldeaUrl(p.name) !== null)
                    : POKE.genFigures(GEN_NUM).map(f => ({ id: f.num, name: f.name, types: [], img: GENERIC_REAL_FALLBACK_IMG, sprite: GENERIC_REAL_FALLBACK_IMG, avail: POKE.availability(f.num) }));
  // search
  if (state.q.trim()) {
    const q = state.q.trim().toLowerCase();
    list = list.filter(p => p.name.toLowerCase().includes(q) || String(p.id).includes(q));
  }
  // types (Kanto/Johto/Hoenn uniquement — seules générations avec des types renseignés)
  if ((isGen1 || isGen2 || isGen3) && state.types.size) {
    list = list.filter(p => p.types.some(t => state.types.has(t)));
  }
  // stock segment
  if (state.segment === "stock") list = list.filter(p => p.avail.kids);
  if (state.segment === "rare")  list = list.filter(p => p.avail.rare);
  // sort
  const sort = state.sort;
  if (sort === "num-asc") list.sort((a,b) => a.id - b.id);
  if (sort === "num-desc") list.sort((a,b) => b.id - a.id);
  if (sort === "name-asc") list.sort((a,b) => a.name.localeCompare(b.name));
  if (sort === "price-asc") list.sort((a,b) => (a.avail.kidsPrice ?? 99) - (b.avail.kidsPrice ?? 99));
  if (sort === "price-desc") list.sort((a,b) => (b.avail.kidsPrice ?? 0) - (a.avail.kidsPrice ?? 0));
  return list;
}

function renderGrid() {
  const root = document.getElementById("dex-grid");
  if (!root) return;
  const isGen1 = GEN_NUM === 1;
  const list = getFilteredSorted();

  // stats
  const stats = document.getElementById("dex-stats");
  const inStock = list.filter(p => p.avail.kids).length;
  if (stats) stats.innerHTML = `
    <span><strong style="color:var(--ink);">${list.length}</strong> résultats</span>
    <span><strong style="color:var(--green-deep);">${inStock}</strong> en stock</span>
    <span style="color:var(--ink-3); margin-left:auto; font-style: italic;">Clique pour ajouter · clique-glisse pour en empiler plein (bundle -10 % dès 5).</span>
  `;

  const ZOOM_BTN = `<button type="button" class="poke-img-zoom" aria-label="Agrandir"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg></button>`;
  const _expandFormTiles = (p, forms) => {
    const t0c = (POKE.TYPES[(p.types || [])[0]] || {}).color || 'var(--ink-3)';
    return forms.map(f => {
      const fOos = !f.inStock;
      const fPicked = hasPick(f.key);
      let varNote = '';
      if (_isSpecialForm(f.label)) {
        const _frN = (p._frName || p.name).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const raw = f.label
          .replace(/^[—–\-\s·]+/, '')
          .replace(new RegExp('^' + _frN + '[—–\\-\\s·]*', 'i'), '')
          .replace(/^[—–\-\s·]+/, '')
          .trim();
        if (raw && !/^\d+$/.test(raw)) {
          const _lang = (() => { try { return localStorage.getItem('mypokea-lang') || 'fr'; } catch { return 'fr'; } })();
          varNote = _lang !== 'fr'
            ? raw.replace(/\bm[eé]ga\b/gi,'Mega').replace(/\bchromatique\b/gi,'Shiny').replace(/\bbrillant[e]?\b/gi,'Shiny')
                 .replace(/\bgigamax\b/gi,'Gigantamax').replace(/\barmure\b/gi,'Armored')
                 .replace(/\balola\b/gi,'Alolan').replace(/\bgalar\b/gi,'Galarian')
                 .replace(/\bhisui\b/gi,'Hisuian').replace(/\bpaldea\b/gi,'Paldean')
            : raw;
        }
      }
      const varLabel = varNote ? `${p.name} · ${varNote}` : p.name;
      const fFootAction = fOos
        ? `<span class="poke-oos-label">Rupture</span>`
        : `<span class="poke-add-btn" aria-hidden="true">+</span>`;
      return `
        <div class="poke-tile ${fOos ? 'oos' : ''} ${fPicked ? 'picked' : ''}"
             data-id="${p.id}" data-form-key="${f.key}"
             title="${f.label} · ${f.inStock ? f.price.toFixed(2).replace('.', ',') + ' €' : 'Rupture'}">
          <span class="poke-pick-badge" aria-hidden="true">${fPicked ? '1' : ''}</span>
          <div class="poke-img-wrap">
            <span class="poke-num">#${String(p.id).padStart(3,'0')}</span>
            <img src="${f.art}" alt="${_altStd(f.name || f.label, f.num)}" loading="lazy" draggable="false" onerror="this.src='${f.sprite}'">
            ${!fOos ? ZOOM_BTN : ''}
          </div>
          <div class="poke-info">
            <div class="poke-name">${varLabel}</div>
            <div class="poke-types-mini"><span class="poke-type-dot" style="--tc: ${t0c}"></span></div>
          </div>
          <div class="poke-foot">
            <span class="poke-price">${f.inStock ? f.price.toFixed(2).replace('.', ',') + ' €' : '—'}</span>
            ${fFootAction}
          </div>
        </div>`;
    });
  };

  const _ALWAYS_EXPAND = new Set([641, 642, 645, 646]);
  root.innerHTML = list.flatMap(p => {
    if (isGen1) {
      const forms = getFormsForId(p.id);
      // expand: always for Pikachu, en mode étendu, en recherche texte, ou en filtre par type
      if (forms.length > 1 && ((p.id === 25 && !state.pikaSingle) || state.expand || !!state.q.trim() || state.types.size)) {
        return _expandFormTiles(p, forms);
      }
    }
    if (_ALWAYS_EXPAND.has(p.id)) {
      const forms = getFormsForGen23(p.id);
      if (forms.length > 1) return _expandFormTiles(p, forms);
    }
    // En mode recherche texte OU filtre par type (gen 2+) : expand toutes les formes comme Gen1
    if (!isGen1 && (state.q.trim() || state.types.size)) {
      const forms = getFormsForGen23(p.id);
      if (forms.length > 0) return _expandFormTiles(p, forms);
    }
    const a = p.avail;
    // Forme la moins chère en stock → image + prix de la tuile (toutes gens)
    const allFormsForTile = isGen1 ? getFormsForId(p.id) : getFormsForGen23(p.id);
    const inStockSorted   = allFormsForTile.filter(f => f.inStock).sort((fa, fb) => fa.price - fb.price);
    const cheapestForm    = inStockSorted[0] || null;
    const hasShopifyForms = allFormsForTile.length > 0;
    const effectiveOos    = hasShopifyForms ? !cheapestForm : !a.kids;
    const tileImg         = (cheapestForm ? cheapestForm.art : null) || p.img || p.sprite;
    const tilePrice       = cheapestForm ? cheapestForm.price : (a.kidsPrice || 0);
    const t0 = POKE.TYPES[p.types[0]] || {};
    const t1 = POKE.TYPES[p.types[1]] || null;
    const picked  = picksForNum(p.id);
    const nForms  = allFormsForTile.length;
    const priceLabel = effectiveOos ? '—' : tilePrice.toFixed(2).replace('.', ',') + ' €';
    const footAction = effectiveOos
      ? `<span class="poke-oos-label">Rupture</span>`
      : nForms > 1
        ? `<span class="poke-forms-cta">${nForms}&nbsp;formes&nbsp;→</span>`
        : `<span class="poke-add-btn" aria-hidden="true">+</span>`;
    return [`
      <div class="poke-tile ${effectiveOos ? 'oos' : ''} ${picked ? 'picked' : ''}"
           data-id="${p.id}"
           title="${p.name} · ${!effectiveOos ? tilePrice.toFixed(2).replace('.', ',') + ' €' : 'Rupture'}">
        <span class="poke-pick-badge" aria-hidden="true">${picked || ''}</span>
        <div class="poke-img-wrap">
          <span class="poke-num">#${String(p.id).padStart(3,'0')}</span>
          <img src="${tileImg}" alt="${_altStd(p.name, p.id)}" loading="lazy" draggable="false" onerror="this.src='${p.sprite}'">
          ${!effectiveOos ? ZOOM_BTN : ''}
        </div>
        <div class="poke-info">
          <div class="poke-name">${p.name}</div>
          <div class="poke-types-mini">
            ${t0.color ? `<span class="poke-type-dot" style="--tc: ${t0.color}"></span>` : ''}
            ${t1 ? `<span class="poke-type-dot" style="--tc: ${t1.color}"></span>` : ''}
          </div>
        </div>
        <div class="poke-foot">
          <span class="poke-price">${priceLabel}</span>
          ${footAction}
        </div>
      </div>
    `];
  }).join("");

  root.querySelectorAll(".poke-tile").forEach(tile => {
    const id = parseInt(tile.dataset.id, 10);
    const imgWrap = tile.querySelector('.poke-img-wrap');
    const footEl  = tile.querySelector('.poke-foot');

    // Clic image → ajoute la forme mise en avant au panier
    if (imgWrap) imgWrap.addEventListener('click', (e) => {
      if (e.target.closest('.poke-img-zoom')) return;
      if (pkDrag.didDrag) { pkDrag.didDrag = false; return; }
      if (tile.classList.contains('oos')) return;
      const formKey = tile.dataset.formKey;
      if (formKey) {
        const allForms = formKey.startsWith('kp-') ? getFormsForId(id) : getFormsForGen23(id);
        const f = allForms.find(x => x.key === formKey);
        if (f) togglePick(f);
        return;
      }
      const allForms = GEN_NUM === 1 ? getFormsForId(id) : getFormsForGen23(id);
      const f = allForms.filter(x => x.inStock).sort((a, b) => a.price - b.price)[0] || allForms[0];
      if (f) togglePick(f);
    });

    // Clic bandeau bas → choix de forme (modal) ou ajout direct si 1 seule forme
    if (footEl) footEl.addEventListener('click', (e) => {
      if (pkDrag.didDrag) { pkDrag.didDrag = false; return; }
      if (tile.classList.contains('oos')) return;
      const formKey = tile.dataset.formKey;
      if (formKey) {
        const allForms = formKey.startsWith('kp-') ? getFormsForId(id) : getFormsForGen23(id);
        const f = allForms.find(x => x.key === formKey);
        if (f) togglePick(f);
        return;
      }
      const allForms = GEN_NUM === 1 ? getFormsForId(id) : getFormsForGen23(id);
      if (allForms.length > 1) { openForms(id); return; }
      const f = allForms.filter(x => x.inStock).sort((a, b) => a.price - b.price)[0] || allForms[0];
      if (f) togglePick(f);
    });
  });

  root.querySelectorAll(".poke-img-zoom").forEach(zoomBtn => {
    zoomBtn.onclick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      const tile = zoomBtn.closest(".poke-tile");
      const id = parseInt(tile.dataset.id, 10);
      const formKey = tile.dataset.formKey;
      if (formKey) {
        const allForms = formKey.startsWith('kp-') ? getFormsForId(id) : getFormsForGen23(id);
        const f = allForms.find(x => x.key === formKey);
        if (f) openZoom(f.art || f.sprite, f.label, f.price > 0 ? f.price : null, f.url);
        return;
      }
      const priceEl = tile.querySelector(".poke-price");
      const priceText = priceEl ? priceEl.textContent.replace(/[^\d,]/g, '').replace(',', '.') : '';
      const price = priceText ? parseFloat(priceText) : null;
      if (GEN_NUM === 2) {
        const po = POKE.GEN2.find(x => x.id === id);
        const img = (po && johtoImg(po.name)) || (po && po.img) || '';
        openZoom(img, po ? po.name : '', price, po ? johtoUrl(po.name) : null);
      } else if (GEN_NUM === 3) {
        const po = POKE.GEN3.find(x => x.id === id);
        const img = (po && hoennImg(po.name)) || (po && po.img) || '';
        openZoom(img, po ? po.name : '', price, po ? hoennUrl(po.name) : null);
      } else if (GEN_NUM === 7) {
        const po = POKE.genFigures(7).find(f => f.num === id);
        const img = (po && alolaImg(po.name)) || (po ? GENERIC_REAL_FALLBACK_IMG : '') || '';
        openZoom(img, po ? po.name : '', price, po ? alolaUrl(po.name) : null);
      } else if (GEN_NUM === 8) {
        const po = POKE.genFigures(8).find(f => f.num === id);
        const img = (po && galarImg(po.name)) || (po ? GENERIC_REAL_FALLBACK_IMG : '') || '';
        openZoom(img, po ? po.name : '', price, po ? galarUrl(po.name) : null);
      } else if (GEN_NUM === 4) {
        const po = POKE.genFigures(4).find(f => f.num === id);
        const img = (po && sinnohImg(po.name)) || (po ? GENERIC_REAL_FALLBACK_IMG : '') || '';
        openZoom(img, po ? po.name : '', price, po ? sinnohUrl(po.name) : null);
      } else if (GEN_NUM === 5) {
        const po = POKE.genFigures(5).find(f => f.num === id);
        const img = (po && unysImg(po.name)) || (po ? GENERIC_REAL_FALLBACK_IMG : '') || '';
        openZoom(img, po ? po.name : '', price, po ? unysUrl(po.name) : null);
      } else if (GEN_NUM === 6) {
        const po = POKE.genFigures(6).find(f => f.num === id);
        const img = (po && kalosImg(po.name)) || (po ? GENERIC_REAL_FALLBACK_IMG : '') || '';
        openZoom(img, po ? po.name : '', price, po ? kalosUrl(po.name) : null);
      } else if (GEN_NUM === 9) {
        const po = POKE.genFigures(9).find(f => f.num === id);
        const img = (po && paldeaImg(po.name)) || (po ? GENERIC_REAL_FALLBACK_IMG : '') || '';
        openZoom(img, po ? po.name : '', price, po ? paldeaUrl(po.name) : null);
      } else {
        const po = POKE.GEN1.find(x => x.id === id);
        const img = (po && kantoImg(po.name)) || (po && po.img) || '';
        openZoom(img, po ? po.name : '', price, po ? kantoUrl(po.name) : null);
      }
    };
  });

  bindDexDragSelect(root);
  renderBundle();
}

/* ============================================================
   Sélection rapide façon Apple Photos pour le Pokédex.
   Appui maintenu + glisser → ajoute la forme de base (en stock) de
   chaque Pokémon survolé à la barre du bas. Un simple clic garde son
   comportement (ouvre le choix des formes). Listeners posés 1 seule fois.
   ============================================================ */
const pkDrag = { on: false, didDrag: false, armed: false, mode: "add", startTile: null, touched: new Set(), bound: false, lpTimer: null };

function baseForm(id) {
  if (GEN_NUM !== 1) {
    const f = POKE.genFigure(GEN_NUM, id);
    const availFn = GEN_NUM === 2 ? johtoAvail : GEN_NUM === 3 ? hoennAvail : GEN_NUM === 4 ? sinnohAvail
      : GEN_NUM === 5 ? unysAvail : GEN_NUM === 6 ? kalosAvail : GEN_NUM === 7 ? alolaAvail
      : GEN_NUM === 8 ? galarAvail : GEN_NUM === 9 ? paldeaAvail : null;
    const priceFn = GEN_NUM === 2 ? johtoPrice : GEN_NUM === 3 ? hoennPrice : GEN_NUM === 4 ? sinnohPrice
      : GEN_NUM === 5 ? unysPrice : GEN_NUM === 6 ? kalosPrice : GEN_NUM === 7 ? alolaPrice
      : GEN_NUM === 8 ? galarPrice : GEN_NUM === 9 ? paldeaPrice : null;
    const imgFn = GEN_NUM === 2 ? johtoImg : GEN_NUM === 3 ? hoennImg : GEN_NUM === 4 ? sinnohImg
      : GEN_NUM === 5 ? unysImg : GEN_NUM === 6 ? kalosImg : GEN_NUM === 7 ? alolaImg
      : GEN_NUM === 8 ? galarImg : GEN_NUM === 9 ? paldeaImg : null;
    const realAvail = availFn ? availFn(f.name) : undefined;
    const inStock = realAvail !== undefined ? realAvail : f.inStock;
    if (!inStock) return null;
    const realPrice = priceFn ? priceFn(f.name) : null;
    const realImg = imgFn ? imgFn(f.name) : null;
    return { ...f, inStock: true, price: realPrice || f.price, sprite: realImg || f.sprite };
  }
  const f = POKE.forms(id).filter(x => x.inStock);
  return f[0] || null;
}
function dexSweep(tile) {
  if (!tile || tile.classList.contains("oos") || pkDrag.touched.has(tile)) return;
  pkDrag.touched.add(tile);
  const formKey = tile.dataset.formKey;
  let f;
  if (formKey) {
    const allForms = getFormsForId(parseInt(tile.dataset.id, 10));
    f = allForms.find(x => x.key === formKey && x.inStock) || null;
  } else {
    f = baseForm(parseInt(tile.dataset.id, 10));
  }
  if (!f) return;
  if (pkDrag.mode === "add") { if (hasPick(f.key)) return; addPickItem(f); }
  else { if (!hasPick(f.key)) return; removePick(f.key); }
  renderBundle(); syncTileBadges();
  tile.classList.add("just-added");
  setTimeout(() => tile.classList.remove("just-added"), 280);
}

function bindDexDragSelect(root) {
  if (pkDrag.bound) return;
  pkDrag.bound = true;

  const tileAt = (x, y) => { const el = document.elementFromPoint(x, y); return el ? el.closest("#dex-grid .poke-tile") : null; };
  const begin = (tile) => {
    pkDrag.on = true; pkDrag.didDrag = true; pkDrag.touched.clear();
    const fk0 = tile.dataset.formKey;
    let f0;
    if (fk0) { const af = getFormsForId(parseInt(tile.dataset.id, 10)); f0 = af.find(x => x.key === fk0) || null; }
    else { f0 = baseForm(parseInt(tile.dataset.id, 10)); }
    pkDrag.mode = (f0 && hasPick(f0.key)) ? "remove" : "add";   // first tile decides: deselect or select
    document.body.classList.add("col-selecting");
    dexSweep(tile);
  };
  const end = () => {
    clearTimeout(pkDrag.lpTimer);
    pkDrag.armed = false;
    if (!pkDrag.on) return;
    pkDrag.on = false;
    document.body.classList.remove("col-selecting");
  };

  // —— mouse : press arms (preventDefault kills native image drag); a drag only
  //    begins after the pointer travels past a distance threshold, so a normal
  //    click (even with a little jitter) still opens the forms popup.
  const DRAG_THRESHOLD = 12;   // px the pointer must move before it's a sweep
  document.addEventListener("mousedown", (e) => {
    const tile = e.target.closest("#dex-grid .poke-tile");
    if (!tile || tile.classList.contains("oos")) return;
    e.preventDefault();
    pkDrag.armed = true; pkDrag.startTile = tile; pkDrag.didDrag = false;
    pkDrag.startX = e.clientX; pkDrag.startY = e.clientY;
    pkDrag.touched.clear();
  });
  window.addEventListener("mousemove", (e) => {
    if (!pkDrag.armed) return;
    if (!pkDrag.on) {
      const dx = e.clientX - pkDrag.startX, dy = e.clientY - pkDrag.startY;
      if (dx * dx + dy * dy < DRAG_THRESHOLD * DRAG_THRESHOLD) return;  // not far enough yet → still a click
      begin(pkDrag.startTile);
    }
    const t = tileAt(e.clientX, e.clientY);
    if (t) dexSweep(t);
  });
  window.addEventListener("mouseup", end);

  // —— touch : long-press starts the sweep (so vertical scroll stays free); tap = normal click
  document.addEventListener("touchstart", (e) => {
    const tile = e.target.closest("#dex-grid .poke-tile");
    if (!tile || tile.classList.contains("oos")) return;
    pkDrag.startTile = tile;
    pkDrag.lpTimer = setTimeout(() => { if (navigator.vibrate) navigator.vibrate(8); begin(tile); }, 180);
  }, { passive: true });
  document.addEventListener("touchmove", (e) => {
    if (!pkDrag.on) { clearTimeout(pkDrag.lpTimer); return; }
    const tt = e.touches[0];
    const tile = tileAt(tt.clientX, tt.clientY);
    if (tile) dexSweep(tile);
  }, { passive: true });
  document.addEventListener("touchend", end);
  document.addEventListener("touchcancel", end);
}

function syncTileBadges() {
  document.querySelectorAll(".poke-tile").forEach(tile => {
    const id = parseInt(tile.dataset.id, 10);
    const formKey = tile.dataset.formKey;
    const n = formKey ? (hasPick(formKey) ? 1 : 0) : picksForNum(id);
    tile.classList.toggle("picked", n > 0);
    const b = tile.querySelector(".poke-pick-badge");
    if (b) b.textContent = n || "";
  });
  syncProgBar();
}

function renderBundle() { if (window.Bundle) Bundle.render(); }

function pulseBundle() {
  const bar = document.getElementById("bundle-bar");
  if (!bar) return;
  bar.classList.remove("pulse"); void bar.offsetWidth; bar.classList.add("pulse");
}

/* ============================================================
   Forms modal — choose among available forms in stock
   ============================================================ */
function ensureFormsModal() {
  if (document.getElementById("forms-modal")) return;
  const m = document.createElement("div");
  m.id = "forms-modal";
  m.innerHTML = `<div class="fm-backdrop" data-fm-close></div><div class="fm-panel" role="dialog" aria-modal="true"></div>`;
  document.body.appendChild(m);
  m.addEventListener("click", e => { if (e.target.closest("[data-fm-close]")) closeForms(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeForms(); });
}
function closeForms() {
  const m = document.getElementById("forms-modal");
  if (m) m.classList.remove("open");
  document.body.style.overflow = "";
}

let fmState = { id: null, sel: null };

function openForms(id) {
  ensureFormsModal();
  const genData = GEN_NUM === 1 ? POKE.GEN1 : GEN_NUM === 2 ? POKE.GEN2 : GEN_NUM === 3 ? POKE.GEN3 : POKE.genFigures(GEN_NUM).map(f => ({ id: f.num, name: f.name, types: [] }));
  const p = genData.find(x => x.id === id);
  if (!p) return;
  const allForms     = GEN_NUM === 1 ? getFormsForId(id) : getFormsForGen23(id);
  const inStockForms = allForms.filter(f => f.inStock);
  fmState = { id, sel: inStockForms[0] ? inStockForms[0].key : null };

  const t0 = POKE.TYPES[p.types[0]] || {};
  const t1 = POKE.TYPES[p.types[1]] || null;
  const panel = document.querySelector("#forms-modal .fm-panel");
  panel.style.setProperty("--accent-pk", t0.color || "var(--sky)");
  const heroImg = GEN_NUM === 1 ? (kantoImg(p.name) || p.img)
    : GEN_NUM === 2 ? (johtoImg(p.name) || p.img)
    : GEN_NUM === 3 ? (hoennImg(p.name) || p.img)
    : GEN_NUM === 4 ? (sinnohImg(p.name) || p.img)
    : GEN_NUM === 5 ? (unysImg(p.name) || p.img)
    : GEN_NUM === 6 ? (kalosImg(p.name) || p.img)
    : GEN_NUM === 7 ? (alolaImg(p.name) || p.img)
    : GEN_NUM === 8 ? (galarImg(p.name) || p.img)
    : GEN_NUM === 9 ? (paldeaImg(p.name) || p.img)
    : p.img;
  const heroFallback = p.sprite || GENERIC_REAL_FALLBACK_IMG;

  panel.innerHTML = `
    <button class="fm-x" data-fm-close aria-label="Fermer">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
    </button>
    <header class="fm-head" style="--pk:${t0.color || 'var(--sky)'}">
      <div class="fm-head-art"><img src="${heroImg}" alt="${_altStd(p.name, p.id)}" onerror="this.onerror=null;this.src='${heroFallback}'"></div>
      <div class="fm-head-info">
        <span class="fm-num">#${String(p.id).padStart(3,'0')}</span>
        <h3>${p.name}</h3>
        <div class="fm-types">
          ${p.types.map(tp => { const T = POKE.TYPES[tp]; return `<span class="fm-type" style="background:${T.color}; color:${T.ink};">${T.label}</span>`; }).join("")}
        </div>
      </div>
    </header>
    <div class="fm-body">
      <div class="fm-section-label">
        <strong>Formes finger puppet disponibles</strong>
        <span>${inStockForms.length} en stock · ${allForms.length} référencées</span>
      </div>
      <p class="fm-hint">Sélectionne une ou plusieurs formes (re-clique pour retirer). Elles s'ajoutent à ta sélection en bas.</p>
      <div class="fm-forms" id="fm-forms">
        ${allForms.map(formRow).join("")}
      </div>
    </div>
    <footer class="fm-foot">
      <span class="fm-foot-count" id="fm-foot-count"></span>
      <button class="btn btn-primary" data-fm-close>Terminé</button>
    </footer>
  `;

  const updateCount = () => {
    const n = picksForNum(id);
    const el = document.getElementById("fm-foot-count");
    if (el) el.textContent = n === 0 ? "Aucune forme sélectionnée" : (n + " forme" + (n > 1 ? "s" : "") + " sélectionnée" + (n > 1 ? "s" : ""));
  };
  panel.querySelectorAll(".fm-form").forEach(el => {
    el.onclick = (e) => {
      if (e.target.closest(".fm-thumb-zoom")) {
        const f = allForms.find(x => x.key === el.dataset.key);
        if (f) openZoom(f.art || f.sprite, f.label, f.price > 0 ? f.price : null, f.url);
        return;
      }
      if (el.classList.contains("oos")) return;
      const f = allForms.find(x => x.key === el.dataset.key);
      if (!f) return;
      togglePick(f);
      el.classList.toggle("on", hasPick(f.key));
      updateCount();
    };
  });
  updateCount();

  document.getElementById("forms-modal").classList.add("open");
  document.body.style.overflow = "hidden";
}

function formRow(f) {
  const on = hasPick(f.key);
  return `
    <button class="fm-form ${f.inStock ? '' : 'oos'} ${on ? 'on' : ''}" data-key="${f.key}" style="--fc:${f.color}">
      <div class="fm-form-thumb ${f.shiny ? 'shiny' : ''}">
        <img src="${f.art}" alt="${_altStd(f.name || f.label, f.num)}" loading="lazy" draggable="false" onerror="this.src='${f.sprite}'">
        ${f.shiny ? '<span class="fm-sparkle">✦</span>' : ''}
        <div class="fm-thumb-zoom"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg></div>
      </div>
      <div class="fm-form-info">
        <span class="fm-form-badge" style="background:${f.color}">${f.badge}</span>
        <strong>${f.label}</strong>
        <span class="fm-form-tag">${f.tag}</span>
      </div>
      <div class="fm-form-right">
        <div class="fm-form-price">${f.price > 0 ? f.price.toFixed(2).replace('.', ',') + ' €' : '—'}</div>
        ${f.inStock
          ? `<div class="fm-stock ok">Disponible</div>
             <span class="fm-check" aria-hidden="true"></span>`
          : `<div class="fm-stock no">Bientôt</div>`}
        ${f.url ? `<a href="${f.url}" class="fm-see-link" target="_blank" rel="noopener" onclick="event.stopPropagation()">Voir la fiche →</a>` : ''}
      </div>
    </button>
  `;
}

function openZoom(img, name, price, url) {
  let ov = document.getElementById("zoom-overlay");
  if (!ov) {
    ov = document.createElement("div");
    ov.id = "zoom-overlay";
    ov.innerHTML = `<div class="zoom-bd"></div><figure class="zoom-fig"><img id="zoom-img" src="" alt=""><figcaption id="zoom-cap"></figcaption><div id="zoom-actions"></div></figure>`;
    document.body.appendChild(ov);
    ov.addEventListener("click", e => { if (e.target === ov || e.target.classList.contains("zoom-bd")) closeZoom(); });
    document.addEventListener("keydown", e => { if (e.key === "Escape") closeZoom(); });
  }
  ov.querySelector("#zoom-img").src = img;
  ov.querySelector("#zoom-img").alt = name;
  ov.querySelector("#zoom-cap").textContent = price && price > 0 ? `${name} · ${price.toFixed(2).replace(".", ",")} €` : name;
  ov.querySelector("#zoom-actions").innerHTML = url ? `<a class="zoom-product-btn" href="${url}" target="_blank" rel="noopener">Voir le produit →</a>` : '';
  ov.classList.add("open");
  document.body.style.overflow = "hidden";
}

function closeZoom() {
  const ov = document.getElementById("zoom-overlay");
  if (ov) ov.classList.remove("open");
  document.body.style.overflow = "";
}

function bindFilters() {
  const searchEl = document.getElementById("dex-search");
  if (searchEl) {
    const _onSearch = e => {
      state.q = e.target.value;
      if (GEN_NUM === 1) {
        state.expand = !!state.q.trim();
        const fab = document.getElementById("dex-expand-fab");
        if (fab) {
          fab.classList.toggle("active", state.expand);
          const lbl = document.getElementById("dex-fab-label");
          if (lbl) lbl.textContent = state.expand ? "Mode étendu ✓" : "Toutes les formes";
        }
      }
      renderGrid();
    };
    searchEl.addEventListener("input", _onSearch);
    searchEl.addEventListener("search", _onSearch); // Safari: fires when X clears the field
  }
  document.querySelectorAll("[data-seg]").forEach(b => {
    b.onclick = () => {
      document.querySelectorAll("[data-seg]").forEach(x => x.classList.remove("on"));
      b.classList.add("on");
      state.segment = b.dataset.seg;
      renderGrid();
    };
  });
  const sortEl = document.getElementById("dex-sort");
  if (sortEl) sortEl.onchange = e => {
    state.sort = e.target.value;
    renderGrid();
  };
  const pikaToggle = document.getElementById("pika-mode-toggle");
  if (pikaToggle) pikaToggle.onclick = () => {
    state.pikaSingle = !state.pikaSingle;
    pikaToggle.textContent = `Pikachu : ${state.pikaSingle ? 'carte unique' : 'formes multiples'}`;
    renderGrid();
  };
}

function updateHeroImages() {
  const realHero = window.HERO_LEGEND_IMAGES;
  if (realHero && realHero.length) {
    realHero.slice(0, 3).forEach((p, i) => {
      const disc = document.getElementById(`hero-disc-${i}`);
      if (!disc) return;
      const imgEl = disc.querySelector('img');
      if (imgEl) { imgEl.src = p.img; imgEl.alt = _altStd(p.name, p.id); }
      if (p.url) { disc.href = p.url; disc.removeAttribute('target'); disc.removeAttribute('rel'); }
      else { disc.removeAttribute('href'); disc.removeAttribute('target'); disc.removeAttribute('rel'); }
    });
    return;
  }
  const legendaries = GEN_HERO_LEGENDARIES[GEN_NUM];
  if (legendaries && legendaries.length) {
    legendaries.slice(0, 3).forEach((p, i) => {
      const disc = document.getElementById(`hero-disc-${i}`);
      if (!disc) return;
      const imgEl = disc.querySelector('img');
      if (imgEl) { imgEl.src = GENERIC_REAL_FALLBACK_IMG; imgEl.alt = _altStd(p.name, p.id); }
      disc.removeAttribute('href'); disc.removeAttribute('target'); disc.removeAttribute('rel');
    });
    return;
  }
  const heroRaw = GEN_NUM === 1 ? window.KANTO_HERO_RAW : GEN_NUM === 2 ? window.JOHTO_HERO_RAW : GEN_NUM === 3 ? window.HOENN_HERO_RAW : GEN_NUM === 4 ? window.SINNOH_HERO_RAW : GEN_NUM === 5 ? window.UNYS_HERO_RAW : GEN_NUM === 6 ? window.KALOS_HERO_RAW : GEN_NUM === 7 ? window.ALOLA_HERO_RAW : GEN_NUM === 8 ? window.GALAR_HERO_RAW : null;
  const heroProds = heroRaw ? heroRaw.filter(p => p.i) : [];
  if (heroProds.length) {
    heroProds.slice(0, 3).forEach((p, i) => {
      const disc = document.getElementById(`hero-disc-${i}`);
      if (!disc) return;
      const imgEl = disc.querySelector('img');
      if (imgEl) { imgEl.src = p.i; imgEl.alt = _altFromTitle(p.t); }
      if (p.u) { disc.href = p.u; disc.target = '_blank'; disc.rel = 'noopener'; }
    });
    return;
  }
  const productsList = GEN_NUM === 1 ? window._kantoProductsList : GEN_NUM === 2 ? window._johtoProductsList : GEN_NUM === 3 ? window._hoennProductsList : GEN_NUM === 4 ? window._sinnohProductsList : GEN_NUM === 5 ? window._unysProductsList : GEN_NUM === 6 ? window._kalosProductsList : GEN_NUM === 7 ? window._alolaProductsList : GEN_NUM === 8 ? window._galarProductsList : null;
  if (!productsList || !productsList.length) return;
  const featured = productsList.filter(p => p.featured && p.img);
  const toShow = (featured.length >= 3 ? featured : productsList.filter(p => p.img)).slice(0, 3);
  toShow.forEach((p, i) => {
    const disc = document.getElementById(`hero-disc-${i}`);
    if (!disc) return;
    const imgEl = disc.querySelector('img');
    if (imgEl && p.img) { imgEl.src = p.img; imgEl.alt = _altFromTitle(p.title); }
    if (p.url) { disc.href = p.url; disc.target = '_blank'; disc.rel = 'noopener'; }
  });
}

function renderExpandFab() {
  let fab = document.getElementById("dex-expand-fab");
  if (!fab) {
    fab = document.createElement("button");
    fab.id = "dex-expand-fab";
    fab.className = "dex-expand-fab";
    fab.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg><span id="dex-fab-label">Toutes les formes</span>`;
    document.body.appendChild(fab);
    fab.onclick = () => {
      state.expand = !state.expand;
      fab.classList.toggle("active", state.expand);
      document.getElementById("dex-fab-label").textContent = state.expand ? "Mode étendu ✓" : "Toutes les formes";
      renderGrid();
    };
  }
  fab.classList.toggle("active", state.expand);
  document.getElementById("dex-fab-label").textContent = state.expand ? "Mode étendu ✓" : "Toutes les formes";
}

function syncProgBar() {
  const picks = window.Bundle ? Bundle.picks : [];
  const count = picks.length;
  const distinct = new Set(picks.map(p => p.num)).size;
  const pn = document.getElementById("prog-num");
  const pb = document.getElementById("prog-bar");
  const pp = document.getElementById("prog-pct");
  if (pn) pn.textContent = count;
  const pct = Math.round(distinct / 151 * 100);
  if (pb) pb.style.width = pct + "%";
  if (pp) pp.textContent = pct + " %";
}
